<template>
	<div>
		<b-modal v-model="ShowBkashNameMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the bkash account.
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					Receiver's Name : {{BkashReceiverName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNo">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYes">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowWalletMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the wallet
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					Receiver's Name : {{BkashReceiverName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNo">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYes">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowMCBNameMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the MCB account.
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					First Name : {{MCBFirstName}} <br>
					Last Name : {{MCBLastName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNoMCB">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYesMCB">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowWingWalletCurrencyMismatchPopup" ref="modal-wingwalletmismatch" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver currency doesn't match the details of the
					registered to the Wing Wallet number.
				</p>
				<p>
					Wing Wallet Account Name : {{WingWalletFullName}} <br>
					Wing Wallet Currency : {{WingWalletCurrency}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleClose">Close</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowIndonesiaAccountMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the Indonesia Bank account.
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					Receiver's Name : {{IndonesiaAccountReceiverName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNoForIndonesiaAcc">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYesForIndonesiaAcc">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowReceiverTypePopup" class="modal-validation" size="md" no-close-on-backdrop="true" no-close-on-esc="true" centered hide-header hide-footer>
			<template v-slot:default>
				<p>
					The entered receiver name appears to be a business name.
				</p>

				<p>
					Would you like to change the receiver type to Business?
				</p>

				<br />

				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleReceiverTypeNo">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleReceiverTypeYes">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Add Recipient</h2>
			</div>
		</div>
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<form @submit.prevent="onSubmit" novalidate="">
						<div class="SetupOneWrapper">
							<div class="form-card">
								<div class="form-card-header">
									<h3>Payment Details </h3>
								</div>
								<div class="form-card-forms">
									<div v-show="IsSetupOne">
										<div class="row">
											<div class="col">
												<div class="form-group">
													<label for="">
														Send Country
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<!-- <select class="form-control" name="CountryId"
														v-model="vModel.CountryId" v-validate="'required'"
														@change="onChangeCountry" data-vv-as='Country'>
														<option value="">Please Select Country</option>
														<option v-for="option in CountryCollection" :key="option.Id"
															:value="option.Id">
															{{option.Text}}
														</option>
													</select> -->
														<kendo-dropdownlist v-if="CountryCollection != null"
																			name='CountryId' v-validate="'required'"
																			class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('CountryId') }"
																			ref="countrydropdownlist" v-model="vModel.CountryId"
																			:data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Country'" :auto-bind="true"
																			:data-source="CountryCollection"
																			:data-value-primitive="true" @change="onChangeCountry"
																			data-vv-as='Country' :filter="'startswith'">
														</kendo-dropdownlist>
														<div v-show="errors.has('CountryId')" class="help is-danger">
															{{ errors.first('CountryId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col">
												<div class="form-group">
													<label for="">
														Payment Network
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<kendo-dropdownlist name='PaymentNetworkId'
																			v-validate="'required'" class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('PaymentNetworkId') }"
																			ref="paymentnetworkdropdownlist"
																			v-model="vModel.PaymentNetworkId" :data-text-field="'Name'"
																			:data-value-field="'Id'"
																			:option-label="'Please Select Payment Network'"
																			:auto-bind="true" :data-source="PaymentNetworkCollection"
																			:data-value-primitive="true"
																			@change="onChangePaymentNetwork"
																			data-vv-as='Payment Network' :valueTemplate="itemTemplate"
																			:template="itemTemplate">
														</kendo-dropdownlist>
														<div v-show="errors.has('PaymentNetworkId')"
															 class="help is-danger">
															{{
 errors.first('PaymentNetworkId')
															}}
														</div>
													</div>
												</div>
											</div>
											<div class="col">
												<div class="form-group">
													<label for="">
														Payment Mode
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="PayoutModeId"
																v-model="vModel.PayoutModeId" v-validate="'required'"
																@change="onChangeDeliveryOption" data-vv-as='Payout mode'>
															<option value="">Please Select Payment Mode</option>
															<option v-for="option in PaymentMethods" :key="option.Id"
																	:value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('PayoutModeId')" class="help is-danger">
															{{ errors.first('PayoutModeId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col" v-if="vModel.PaymentNetworkId == 2 || vModel.PaymentNetworkId == 3">
												<div class="form-group">
													<label for="">
														Currency
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="CurrencyId"
																v-model="vModel.CurrencyId" v-validate="'required'"
																@change="onChangeCurrency" data-vv-as='Currency'>
															<option value="">Please Select Currency</option>
															<option v-for="option in CurrencyCollection"
																	:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('CurrencyId')" class="help is-danger">
															{{ errors.first('CurrencyId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col" v-if="vModel.PaymentNetworkId == 1 && vModel.CountryName == 'Cambodia'">
												<div class="form-group">
													<label for="">
														Currency
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="CurrencyId"
																v-model="vModel.CurrencyId" v-validate="'required'"
																@change="onChangeCurrency" data-vv-as='Currency'>
															<option value="">Please Select Currency</option>
															<option v-for="option in CurrencyCollection"
																	:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('CurrencyId')" class="help is-danger">
															{{ errors.first('CurrencyId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col" v-if="vModel.PayoutModeId == 97">
												<div class="form-group">
													<label for="">
														<strong>Payout Location</strong>
													</label>
													<div class="mb-3">
														<label>
															<a href="https://www.westernunion.com/MY/en/find-locations.html"
															   target="_blank">
																Click
																Here
															</a> <small>
																to view WU Payout
																Location
															</small>
														</label>
													</div>
												</div>
											</div>
											<div class="col" v-if="vModel.PaymentNetworkId == 1 && vModel.CountryName == 'China' && vModel.PayoutModeName == 'Union Pay Card'">
												<div class="form-group">
													<label for="">
														Payout Name
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<kendo-dropdownlist name='AgentId' v-if="PayoutGroupCollection!=null" class="form-control" @change="onChangePayoutGroup" data-vv-as='Payout Name'
																			v-model="vModel.AgentId" :data-text-field="'Text'" :data-value-field="'Id'" ref="payoutagentdropdownlist"
																			:option-label="'Please Select Payout Name'" :auto-bind="true" :data-source="PayoutGroupCollection"
																			:data-value-primitive="true">
														</kendo-dropdownlist>
														<input type="hidden" v-model="vModel.AgentId"
															   v-validate="'required'" data-vv-as="Payout Name"
															   id="AgentId" name="AgentId" />
														<div v-show="errors.has('AgentId')" class="help is-danger">
															{{ errors.first('AgentId') }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-show="!IsSetupOne">
										<div class="row">
											<div class="col-md-3">
												<div class="form-group">
													<label for="">
														Country
													</label>
													<div class="input-group mb-3">
														{{vModel.CountryName}}
													</div>
												</div>
											</div>
											<div class="col-md-3">
												<div class="form-group">
													<label for="">
														Payment Network
													</label>
													<div class="input-group mb-3">
														<img :src="vModel.PaymentNetworkIcon" height="25"
															 width="25">&nbsp; {{vModel.PaymentNetworkName}}
													</div>
												</div>
											</div>
											<div class="col-md-3">
												<div class="form-group">
													<label for="">
														Payout Mode
													</label>
													<div class="input-group mb-3">
														{{vModel.PayoutModeName}}
													</div>
												</div>
											</div>
											<div class="col-md-3" v-if="vModel.PaymentNetworkId == 2 || vModel.PaymentNetworkId == 3 || (vModel.PaymentNetworkId == 1 && vModel.CountryName == 'Cambodia')">
												<div class="form-group">
													<label for="">
														Currency
													</label>
													<div class="input-group mb-3">
														{{vModel.CurrencyName}}
													</div>
												</div>
											</div>
											<div class="col-md-3" v-if="vModel.PaymentNetworkId == 1 && vModel.CountryName == 'China' && vModel.PayoutModeName == 'Union Pay Card'">
												<div class="form-group">
													<label for="">
														Payout Name
													</label>
													<div class="input-group mb-3">
														{{vModel.PayoutGroupName}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="submit-option" v-if="IsSetupOne">
							<div class="left-option">
								<button class="btn submit-lefticon-btn" @click="onCancel()" type="button">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</button>
							</div>
							<div class="right-option">
								<button class="btn submit-righticon-btn">
									<span class="btn-content">Next</span>
									<span class="right-icon">
										<i class="material-icons">chevron_right</i>
									</span>
								</button>
							</div>
						</div>
						<div v-else>
							<div v-if="vModel.PaymentNetworkId == '3'">
								<div>
									<div class="form-card">
										<div class="form-card-header">
											<h3>Reciever Details</h3>
										</div>
										<div class="form-card-forms">
											<div class="row">
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.FirstName != null">
													<div class="form-group">
														<label for="">
															First Name
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   id="FirstName" name="FirstName" autocomplete="off"
															   v-model="vModel.FirstName" v-validate="'required|max:100'"
															   :data-vv-as='FieldValidation.FirstName.WebRequiredMessage'
															   v-only-text="" v-only-uppercase />
														<div v-show="errors.has('FirstName')" class="help is-danger">
															{{errors.first('FirstName') }}
														</div>
													</div>
												</div>
												<!-- <div class="col-lg-4"
												v-if="FieldValidation != null && FieldValidation.MiddleName != null">
												<div class="form-group">
													<label for="">Middle Name</label>
													<input type="text" class="form-control text-uppercase"
														name="MiddleName" autocomplete="off" v-validate="'max:100'"
														:data-vv-as='FieldValidation.MiddleName.WebRequiredMessage'
														v-model="vModel.MiddleName" v-only-text v-only-uppercase />
													<div v-show="errors.has('MiddleName')" class="help is-danger">
														{{ errors.first('MiddleName') }}</div>
												</div>
											</div> -->
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.LastName != null">
													<div class="form-group">
														<label for="">
															Last Name
															<span v-if="FieldValidation.LastName.Required == true"
																  class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   name="LastName" autocomplete="off" v-model="vModel.LastName"
															   v-validate="FieldValidation.LastName.Required == true ? 'required|max:100': ''"
															   :data-vv-as='FieldValidation.LastName.WebRequiredMessage'
															   v-only-text="" v-only-uppercase />
														<div v-show="errors.has('LastName')" class="help is-danger">
															{{ errors.first('LastName') }}
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.RelationshipId != null">
													<div class="form-group">
														<label for="">
															Relationship
															<span class="required">*</span>
														</label>
														<div class="mb-3">
															<select class="form-control" name="RelationShipId" @change="onChangeRelationship"
																	v-model="vModel.RelationShipId" v-validate="'required'"
																	:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
																<option value="">Please Select Relationship</option>
																<option v-for="option in RelationShipCollection"
																		:key="option.Id" :value="option.Id">
																	{{option.Text}}
																</option>
															</select>
															<div v-show="errors.has('RelationShipId')"
																 class="help is-danger">
																{{ errors.first('RelationShipId') }}
															</div>
															<div v-show="showAdditionalRelationshipMessage"
																 class="help is-danger">
																{{ additionalRelationshipMessage }}
															</div>
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId != 251) || (FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 251 && (vModel.PayoutModeId == 97 || vModel.PayoutModeId == 101 || vModel.PayoutModeId == 102))">
													<div class="form-group">
														<label for="">
															Mobile Number
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="18"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
														<div v-show="errors.has('MobileContact')"
															 class="help is-danger">
															{{ errors.first('MobileContact') }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="submit-option">
									<div class="left-option">
										<router-link :to="'/recipient/visadirect'" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="material-icons">chevron_left</i>
											</span>
											<span class="btn-content">Cancel</span>
										</router-link>
									</div>
									<div class="right-option">
										<button class="btn submit-righticon-btn">
											<span class="btn-content">Create</span>
											<span class="right-icon">
												<i class="material-icons">chevron_right</i>
											</span>
										</button>
									</div>
								</div>
							</div>
							<div v-if="vModel.PaymentNetworkId == '2'">
								<div v-if="vModel.PayoutModeId == '98'">
									<div class="form-card">
										<div class="form-card-header">
											<h3>Bank Details</h3>
										</div>
										<div class="form-card-forms">
											<form-generator :schema="bankSection" v-model="D2BData">
											</form-generator>
										</div>
									</div>
								</div>
								<div>
									<div class="form-card">
										<div class="form-card-header">
											<h3>Reciever Details</h3>
										</div>
										<div class="form-card-forms">
											<div class="row">
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.FirstName != null">
													<div class="form-group">
														<label for="">
															First Name
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   id="FirstName" name="FirstName" autocomplete="off"
															   v-model="vModel.FirstName" v-validate="'required|max:100'"
															   :data-vv-as='FieldValidation.FirstName.WebRequiredMessage'
															   v-only-text="" v-only-uppercase />
														<div v-show="errors.has('FirstName')" class="help is-danger">
															{{errors.first('FirstName') }}
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.MiddleName != null">
													<div class="form-group">
														<label for="">Middle Name</label>
														<input type="text" class="form-control text-uppercase"
															   name="MiddleName" autocomplete="off" v-validate="'max:100'"
															   :data-vv-as='FieldValidation.MiddleName.WebRequiredMessage'
															   v-model="vModel.MiddleName" v-only-text v-only-uppercase />
														<div v-show="errors.has('MiddleName')" class="help is-danger">
															{{ errors.first('MiddleName') }}
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.LastName != null">
													<div class="form-group">
														<label for="">
															Last Name
															<span v-if="FieldValidation.LastName.Required == true"
																  class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   name="LastName" autocomplete="off" v-model="vModel.LastName"
															   v-validate="FieldValidation.LastName.Required == true ? 'required|max:100': ''"
															   :data-vv-as='FieldValidation.LastName.WebRequiredMessage'
															   v-only-text="" v-only-uppercase />
														<div v-show="errors.has('LastName')" class="help is-danger">
															{{ errors.first('LastName') }}
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="FieldValidation != null && FieldValidation.RelationshipId != null">
													<div class="form-group">
														<label for="">
															Relationship
															<span class="required">*</span>
														</label>
														<div class="mb-3">
															<select class="form-control" name="RelationShipId" @change="onChangeRelationship"
																	v-model="vModel.RelationShipId" v-validate="'required'"
																	:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
																<option value="">Please Select Relationship</option>
																<option v-for="option in RelationShipCollection"
																		:key="option.Id" :value="option.Id">
																	{{option.Text}}
																</option>
															</select>
															<div v-show="errors.has('RelationShipId')"
																 class="help is-danger">
																{{ errors.first('RelationShipId') }}
															</div>
															<div v-show="showAdditionalRelationshipMessage"
																 class="help is-danger">
																{{ additionalRelationshipMessage }}
															</div>
														</div>
													</div>
												</div>
												<div class="col-lg-4"
													 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId != 251) || (FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 251 && vModel.PayoutModeId == 97)">
													<div class="form-group">
														<label for="">
															Mobile Number
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="18"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
														<div v-show="errors.has('MobileContact')"
															 class="help is-danger">
															{{ errors.first('MobileContact') }}
														</div>
													</div>
												</div>
												<div class="col-md-4"
													 v-if="FieldValidation != null && FieldValidation.StateId != null">
													<div class="form-group">
														<label for="">
															State
															<span class="required">*</span>
														</label>
														<div class="mb-3">
															<select class="form-control" name="StateId"
																	v-model="vModel.StateId" v-validate="'required'"
																	@change="onChangeState"
																	:data-vv-as='FieldValidation.StateId.WebRequiredMessage'>
																<option value="">Select</option>
																<option v-for="option in StatesCollection"
																		:key="option.Id" :value="option.Id">
																	{{option.Text}}
																</option>
															</select>
															<div v-show="errors.has('StateId')" class="help is-danger">
																{{ errors.first('StateId') }}
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-4"
													 v-if="FieldValidation != null && FieldValidation.City != null && vModel.CountryId != 159">
													<div class="form-group">
														<label for="">
															City / Town
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   name="City" autocomplete="off" v-model="vModel.City"
															   :data-vv-as='FieldValidation.City.WebRequiredMessage'
															   v-validate="'required|max:50'"
															   :class="{'input': true, 'is-danger': errors.has('City') }"
															   v-only-uppercase />
														<div v-show="errors.has('City')" class="help is-danger">
															{{ errors.first('City') }}
														</div>
													</div>
												</div>
												<div class="col-md-4"
													 v-if="FieldValidation != null && FieldValidation.City != null && vModel.CountryId == 159 && vModel.PayoutModeId == 97">
													<div class="form-group">
														<label for="">
															City / Town
															<span class="required">*</span>
														</label>
														<div class="mb-3">
															<select class="form-control" name="CityId"
																	v-model="vModel.City" v-validate="'required'"
																	:data-vv-as='FieldValidation.City.WebRequiredMessage'>
																<option value="">Select</option>
																<option v-for="option in MexicoCities" :key="option.Id"
																		:value="option.Id">
																	{{option.Text}}
																</option>
															</select>
															<div v-show="errors.has('CityId')" class="help is-danger">
																{{ errors.first('CityId') }}
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-4"
													 v-if="FieldValidation != null && FieldValidation.PostCode != null">
													<div class="form-group">
														<label for="">
															Post Code
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   name="PostCode" autocomplete="off" v-model="vModel.PostCode"
															   :data-vv-as='FieldValidation.PostCode.WebRequiredMessage'
															   v-validate="vModel.CountryId == 251 ? 'required' : vModel.CountryId == 123 ? 'required|JapanPostCode' : 'required:max:10'"
															   :class="{'input': true, 'is-danger': errors.has('PostCode') }">
														<div v-show="errors.has('PostCode')" class="help is-danger">
															{{ errors.first('PostCode') }}
														</div>
													</div>
												</div>
												<div class="col-md-4"
													 v-if="FieldValidation != null && FieldValidation.Street != null&& vModel.ReceiverTypeId != 2">
													<div class="form-group">
														<label>
															Street Address
															<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															   name="Street" autocomplete="off" v-model="vModel.Street"
															   v-validate="'required|max:75'"
															   :data-vv-as='FieldValidation.Street.WebRequiredMessage'
															   :class="{'input': true, 'is-danger': errors.has('Street') }"
															   v-only-uppercase />
														<div v-show="errors.has('Street')" class="help is-danger">
															{{ errors.first('Street') }}
														</div>
													</div>
												</div>
											</div>
											<div v-if="vModel.PayoutModeId == '98'">
												<form-generator :schema="recipientSection" v-model="D2BData">
												</form-generator>
											</div>
										</div>
									</div>
								</div>
								<div class="submit-option">
									<div class="left-option">
										<router-link :to="'/recipient/westernunion'" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="material-icons">chevron_left</i>
											</span>
											<span class="btn-content">Cancel</span>
										</router-link>
									</div>
									<div class="right-option">
										<button class="btn submit-righticon-btn">
											<span class="btn-content">Create</span>
											<span class="right-icon">
												<i class="material-icons">chevron_right</i>
											</span>
										</button>
									</div>
								</div>
							</div>
							<div v-if="vModel.PaymentNetworkId == '1'">
								<div v-if="vModel.PayoutModeId == 1 || vModel.PayoutModeId == 24 || vModel.PayoutModeId == 25 || vModel.PayoutModeId == 27 || vModel.PayoutModeId == 28 || vModel.PayoutModeId == 29">
									<div class="form-card">
										<div class="form-card-header">
											<h3>
												{{vModel.PayoutModeId == 24 ? "eWallet Number Details" : "Bank Details"}}
											</h3>
										</div>
										<div class="form-card-forms">
											<div class="shaded-section">
												<div class="row">
													<div class="col-sm-4"
														 v-if="FieldValidation != null && FieldValidation.BankId != null">
														<div class="form-group">
															<label>
																{{vModel.PayoutModeId == 24 ? "eWallet Type" : "Bank Name"}}
																<span class="required">*</span>
															</label>
															<kendo-dropdownlist v-if="BankCollection != null"
																				name='BankId' v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('BankId') }"
																				ref="bankdropdownlist" v-model="vModel.BankId"
																				:data-text-field="'Text'" :data-value-field="'Id'"
																				:option-label="'Please Select Bank'" :auto-bind="true"
																				:data-source="BankCollection"
																				:data-value-primitive="true" :filter="'startswith'"
																				@change="onChangeBankDropDown"
																				:data-vv-as='FieldValidation.BankId.WebRequiredMessage'
																				@dataBound="onBankDropDownBound">
															</kendo-dropdownlist>
															<div v-show="errors.has('BankId')" class="help is-danger">
																{{ errors.first('BankId') }}
															</div>
														</div>
													</div>
													<div class="col-sm-4"
														 v-if="FieldValidation != null && FieldValidation.WalletTypeId != null && (vModel.PayoutModeId == 28 || (vModel.PayoutModeId == 29 && vModel.CountryId == 10))">
														<div class="form-group">
															<label>
																eWallet Type <span class="required">*</span>
															</label>
															<kendo-dropdownlist v-if="WalletTypeCollection != null"
																				name='WalletTypeId'
																				v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('WalletTypeId') }"
																				ref="wallettypelist" v-model="vModel.WalletTypeId"
																				:data-text-field="'Text'" :data-value-field="'Id'"
																				:option-label="'Please Select eWallet Type'" :auto-bind="true"
																				:data-source="WalletTypeCollection"
																				:data-value-primitive="true" :filter="'startswith'"
																				@change="onChangeWalletDropDown"
																				:data-vv-as='FieldValidation.WalletTypeId.WebRequiredMessage'
																				@dataBound="onBankDropDownBound">
															</kendo-dropdownlist>
															<div v-show="errors.has('WalletTypeId')" class="help is-danger">
																{{ errors.first('WalletTypeId') }}
															</div>
														</div>
													</div>

													<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.AccountNumber != null && (vModel.PayoutModeId == 24 || vModel.PayoutModeId == 28 || vModel.PayoutModeId == 29)">
														<div class="form-group">
															<div>
																<label>
																	eWallet Number
																	<span class="required">*</span>
																</label>
															</div>
															<div class="input-group">
																<div class="input-group-prepend"
																	 v-if="FieldValidation != null && FieldValidation.AccountPrefix != null && IsPrefixAvaliable">
																	<kendo-dropdownlist name='AccountPrefix'
																						v-validate="this.vModel.PayoutModeId==28 ? {required: true, regex: '^[a-zA-Z0-9]*$'} : {required: true}"
																						class="form-control"
																						:class="{'input': true, 'is-danger': errors.has('AccountPrefix') }"
																						ref="AccountPrefix" v-model="vModel.AccountPrefix"
																						:data-text-field="'Text'" :data-value-field="'Text'"
																						:auto-bind="true"
																						:data-source="AccountPrefix"
																						:data-value-primitive="true"
																						:data-vv-as='required'
																						@dataBound="onBankDropDownBound">
																	</kendo-dropdownlist>

																	<div v-show="errors.has('AccountPrefix')" class="help is-danger">
																		{{ errors.first('AccountPrefix') }}
																	</div>
																</div>
																<div class="input-group-prepend" v-show="showGcashAccountPrefix">
																	<span class="input-group-text">09</span>
																</div>
																<input type="text" class="form-control" name="AccountNumber"
																	   v-validate="this.vModel.PayoutModeId==28 ? {required: true, regex: '^[a-zA-Z0-9]*$'} : {required: true,regex:'^[0-9]*$'}"
																	   autocomplete="off" v-model="vModel.AccountNumber"
																	   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
																	   maxlength="20"
																	   :class="{'input': true, 'is-danger': errors.has('AccountNumber'),'ml-5':IsPrefixAvaliable }">
															</div>

															<div v-show="errors.has('AccountNumber')" class="help is-danger">
																{{ errors.first('AccountNumber') }}
															</div>
														</div>
													</div>

													<div class="col-sm-8"
														 v-if="FieldValidation != null && FieldValidation.IFSC != null && vModel.CountryId == 2">
														<div class="form-group">
															<div class="row">
																<div class="col-sm-6">
																	<label>
																		Bank's IFSC
																		<span class="required">*</span>
																	</label>
																	<input type="text"
																		   class="form-control text-uppercase" id="name"
																		   name="IFSC" autocomplete="off"
																		   v-model="vModel.IFSC"
																		   :data-vv-as='FieldValidation.IFSC.WebRequiredMessage'
																		   v-validate="'required'"
																		   :class="{'input': true, 'is-danger': errors.has('IFSC') }"
																		   v-only-uppercase>
																	<div v-show="errors.has('IFSC')"
																		 class="help is-danger">
																		{{ errors.first('IFSC') }}
																	</div>
																</div>
																<div class="col-sm-12">
																	<div>
																		<small>
																			The Indian Financial System Code (IFSC Code)
																			is a code of 11 numbers and letters that
																			uniquely identifies the bank branch.
																		</small>
																	</div>
																	<div>
																		<a href="http://www.ifsccodebank.com/"
																		   target="_blank" style="color: red">
																			Don't
																			know the IFSC Code?
																		</a>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div class="col-sm-4"
														 v-if="FieldValidation != null && FieldValidation.BranchId != null  && vModel.CountryId !=2 ">
														<div class="form-group">
															<label>
																Branch
																<span class="required">*</span>
															</label>
															<kendo-dropdownlist name='Branch' v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('Branch') }"
																				:data-vv-as='FieldValidation.BranchId.WebRequiredMessage'
																				v-model="vModel.BranchId" :data-text-field="'Text'"
																				:data-value-field="'Id'"
																				:option-label="'Please Select Branch'" :auto-bind="true"
																				:index="0" :data-value-primitive="true"
																				:filter="'startswith'" ref="branchdropdownlist">
															</kendo-dropdownlist>
															<div v-show="errors.has('Branch')" class="help is-danger">
																{{ errors.first('Branch') }}
															</div>
														</div>
													</div>

													<div class="col-sm-4" v-if="vModel.CountryId == 251 && vModel.PayoutModeId == 1 && FieldValidation!=null && FieldValidation.AccountTypeId != null">
														<div class="form-group">
															<label>
																Account Type
																<span class="required">*</span>
															</label>
															<kendo-dropdownlist v-if="AccountTypeCollection != null"
																				name='AccountType' v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('AccountType') }"
																				ref="accounttypedropdownlist" v-model="vModel.AccountTypeId"
																				:data-text-field="'Text'" :data-value-field="'Id'"
																				:option-label="'Please Select Account Type'" :auto-bind="true"
																				:data-source="AccountTypeCollection"
																				:data-value-primitive="true" :filter="'startswith'"
																				:data-vv-as='FieldValidation.AccountTypeId.WebRequiredMessage'
																				@change="onChangeAccountType">
															</kendo-dropdownlist>
															<div v-show="errors.has('AccountType')" class="help is-danger">
																{{ errors.first('AccountType') }}
															</div>
														</div>
													</div>

													<div class="col-lg-4"
														 v-if="vModel.CountryId == 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && !accountNoValidation.IsAccValidationActive">
														<div class="form-group">
															<div>
																<label>
																	Account Number
																	<span class="required">*</span>
																</label>
															</div>
															<input type="text" class="form-control text-uppercase"
																   name="AccountNumber" autocomplete="off" v-mask="accountMask"
																   v-model="vModel.AccountNumber"
																   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
																   v-only-text-number='' maxlength="30"
																   v-validate="'required|BankAccount:'+vModel.CountryId"
																   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
																   v-only-uppercase>
															<div v-show="errors.has('AccountNumber')" class="help is-danger" v-html="errors.first('AccountNumber')">
															</div>

														</div>
													</div>

													<div class="col-lg-8"
														 v-if="vModel.CountryId == 251 && FieldValidation != null && FieldValidation.AccountNumber != null && FieldValidation.AccountNumber.Note">
														<div class="col-lg-12">
															<label>
																<font color='red'>
																	Note: <br />
																	{{FieldValidation.AccountNumber.Note}}
																</font>
															</label>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-lg-4"
														 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 48 && vModel.PayoutModeId == 25">
														<div class="form-group">

															<div>
																<label>
																	Wing Wallet Number
																	<span class="required">*</span>
																</label>
															</div>
															<div class="input-group">
																<input type="text" class="form-control text-uppercase"
																	   name="AccountNumber" autocomplete="off" v-mask="accountMask"
																	   v-model="vModel.AccountNumber"
																	   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
																	   v-only-numeric='' maxlength="10" minlength="8"
																	   v-validate="'required|BankAccount:'+vModel.CountryId"
																	   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
																	   v-only-uppercase>

															</div>
															<div v-show="errors.has('AccountNumber')" class="help is-danger">
																{{ errors.first('AccountNumber') }}
															</div>

														</div>

													</div>
													<div class="col-lg-2" style="margin-top: 36px;"
														 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 48 && vModel.PayoutModeId == 25">
														<button class="btn red-btn" @click="verifyWingWalletNumber()" :disabled="IsWingWalletVerify" type="button">
															<span class="btn-content">Verify</span>
														</button>
													</div>
													<div class="row">
														<div class="col-lg-12" v-if="IsWingWalletValidationChecked">
															<label>
																<strong>Result</strong><br>
																<strong>Account Name : {{this.WingWalletFullName}}</strong><br>
																<strong>Currency : {{this.WingWalletCurrency}}</strong><br />
																<strong v-if="this.IsValidWingWalletNumber">Validation : Success</strong>
																<strong v-else-if="!this.IsValidWingWalletNumber">Validation : Failed</strong>
															</label>
														</div>
													</div>
												</div>


												<div class="row" v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 56 && vModel.PayoutModeId == 27">
													<div class="col-lg-4">
														<div class="form-group">
															<div>
																<label>Wallet Number<span class="required">*</span></label>
															</div>
															<div class="input-group">
																<div class="input-group-prepend"><span class="input-group-text" style="color:#000;"><span>+ </span></span></div>
																<input type="text" class="form-control text-uppercase"
																	   name="AccountNumber" autocomplete="off" v-mask="accountMask"
																	   v-model="vModel.AccountNumber"
																	   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
																	   v-only-numeric
																	   v-validate="'required'"
																	   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
																	   v-only-uppercase>
															</div>
															<div v-show="errors.has('AccountNumber')" class="help is-danger">
																{{ errors.first('AccountNumber') }}
															</div>
														</div>
													</div>
													<div class="col-lg-2" style="margin-top: 36px;">
														<button class="btn red-btn" @click="verifyWeixinWalletNumber()" :disabled="IsWeixinWalletVerify" type="button">
															<span class="btn-content">Verify</span>
														</button>
													</div>
													<div class="row">
														<div class="col-lg-12" v-if="IsWeixinWalletValidationChecked">
															<label>
																<strong>Result</strong><br>
																<div v-if="this.IsValidWeixinWalletNumber">
																	<strong>Last Name : {{this.WeixinWalletFullName}}</strong><br>
																</div>
																<strong v-if="this.IsValidWeixinWalletNumber">Validation : Success</strong>
																<strong v-else-if="!this.IsValidWeixinWalletNumber">Validation : Failed</strong>
															</label>
														</div>
													</div>
												</div>

											</div>
											<div class="shaded-section">
												<div class="row">
													<div class="col-sm-4" v-if="FieldValidation!=null && FieldValidation.ReceiverTypeId != null">
														<div class="form-group">
															<label>
																Receiver Type
																<span class="required">*</span>
															</label>
															<kendo-dropdownlist v-if="ReceiverTypeCollection != null"
																				name='ReceiverType' v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('ReceiverType') }"
																				ref="receivertypedropdownlist" v-model="vModel.ReceiverTypeId"
																				:data-text-field="'Text'" :data-value-field="'Id'"
																				:option-label="'Please Select Receiver Type'" :auto-bind="true"
																				:data-source="ReceiverTypeCollection"
																				:data-value-primitive="true" :filter="'startswith'"
																				:data-vv-as='FieldValidation.ReceiverTypeId.WebRequiredMessage'
																				@change="onChangeReceiverType">
															</kendo-dropdownlist>
															<div v-show="errors.has('ReceiverType')" class="help is-danger">
																{{ errors.first('ReceiverType') }}
															</div>
														</div>
													</div>
												</div>

											</div>
										</div>
									</div>
								</div>
								<div v-if="vModel.PayoutModeId == 2 ||vModel.PayoutModeId == 34 ||vModel.PayoutModeId == 35">
									<div class="form-card">
										<div class="form-card-header">
											<h3>Agent Details</h3>
										</div>
										<div class="form-card-forms">
											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Agent
															<span class="required">*</span>
														</label>
														<kendo-dropdownlist v-if="AgentCollection != null"
																			name='AgentId' v-validate="'required'" class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('AgentId') }"
																			ref="agentdropdownlist" v-model="vModel.AgentId"
																			:data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Agent'" :auto-bind="true"
																			:data-source="AgentCollection" :data-value-primitive="true"
																			data-vv-as="Receivers agent" @change="onChangeAgentDropDown"
																			@dataBound="onAgentDropDownBound">
														</kendo-dropdownlist>
														<div v-show="errors.has('AgentId')" class="help is-danger">
															{{ errors.first('AgentId') }}
														</div>
													</div>
												</div>
												<div class="col-lg-6">
													<div class="form-group">
														<label for="">Remarks</label>
														<div class="input-group mb-3">
															<p class="notice">{{Remarks}}</p>
														</div>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-lg-12">
													<div class="form-group">
														<p class="notice">{{Note}}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div v-if="(FieldValidation != null && FieldValidation.WalletNumber != null)">
									<div class="form-card">
										<div class="form-card-header">
											<h3>Bank Details</h3>
										</div>
										<div class="form-card-forms">
											<div class="row">
												<div class="col-lg-4">
													<div class="form-group">
														<label for="">
															Wallet Number
															<span class="required">*</span>
														</label>
														<div class="form-group">
															<input type="text" class="form-control" name="MobileContact"
																   autocomplete="off" v-mobile-normal="" maxlength="18"
																   v-model="vModel.MobileContact"
																   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
																   v-validate="'required|max:18|mobile'"
																   :class="{'input': true, 'is-danger': errors.has('MobileContact') }">
															<div v-show="errors.has('MobileContact')" class="help is-danger">
																{{ errors.first('MobileContact') }}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>


								<div class="form-card" :key="'receiver-section-' + vModel.ReceiverTypeId">
									<div class="form-card-header">
										<h3>Recipient Details</h3>
									</div>
									<div class="form-card-forms">
										<div v-if="vModel.PayoutModeId == 2 ||vModel.PayoutModeId == 34 ||vModel.PayoutModeId == 35">
											<div class="row">
												<div class="col-sm-4" v-if="FieldValidation!=null && FieldValidation.ReceiverTypeId != null">
													<div class="form-group">
														<label>
															Receiver Type
															<span class="required">*</span>
														</label>
														<kendo-dropdownlist v-if="ReceiverTypeCollection != null"
																			name='ReceiverType' v-validate="'required'"
																			class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('ReceiverType') }"
																			ref="receivertypedropdownlist" v-model="vModel.ReceiverTypeId"
																			:data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Receiver Type'" :auto-bind="true"
																			:data-source="ReceiverTypeCollection"
																			:data-value-primitive="true" :filter="'startswith'"
																			:data-vv-as='FieldValidation.ReceiverTypeId.WebRequiredMessage'
																			@change="onChangeReceiverType">
														</kendo-dropdownlist>
														<div v-show="errors.has('ReceiverType')" class="help is-danger">
															{{ errors.first('ReceiverType') }}
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="row">

											<div class="col-lg-8"
												 v-if="vModel.ReceiverTypeId == 2 && FieldValidation != null && FieldValidation.CompanyName != null">
												<div class="form-group">
													<label for="">
														Company Name
														<span v-if="FieldValidation.CompanyName.Required == true"
															  class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="CompanyName" autocomplete="off" v-model="vModel.CompanyName"
														   :data-vv-as='FieldValidation.CompanyName.WebRequiredMessage'
														   :class="{'input': true, 'is-danger': errors.has('CompanyName') }"
														   v-only-uppercase />
													<div v-show="errors.has('CompanyName')" class="help is-danger">
														{{ errors.first('CompanyName') }}
													</div>

												</div>
											</div>

											<div class="col-lg-4"
												 v-if="vModel.ReceiverTypeId != 2 && FieldValidation != null && FieldValidation.FirstName != null">
												<div class="form-group">
													<label for="">
														First Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
														   name="FirstName" autocomplete="off" v-model="vModel.FirstName"
														   :data-vv-as='FieldValidation.FirstName.WebRequiredMessage'
														   :class="{'input': true, 'is-danger': errors.has('FirstName') }"
														   v-validate="this.GroupCode=='KH03' ? {required: true, regex: '^[A-Za-z ]+$'} : {required: true}"
														   v-only-uppercase />
													<div v-show="errors.has('FirstName')" class="help is-danger">
														{{ errors.first('FirstName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="vModel.ReceiverTypeId != 2 && FieldValidation != null && FieldValidation.LastName != null">
												<div class="form-group">
													<label for="">
														Last Name
														<span v-if="FieldValidation.LastName.Required == true"
															  class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
														   name="LastName" autocomplete="off" v-model="vModel.LastName"
														   :data-vv-as='FieldValidation.LastName.WebRequiredMessage'
														   v-validate="FieldValidation.LastName.Required == true ? (this.GroupCode=='KH03' ? {required: true, regex: '^[A-Za-z ]+$'} : {required: true}) : (this.GroupCode=='KH03' ? {regex: '^[A-Za-z ]+$'} : '')"
														   :class="{'input': true, 'is-danger': errors.has('LastName') }"
														   v-only-uppercase />
													<div v-show="errors.has('LastName')" class="help is-danger">
														{{ errors.first('LastName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.RelationshipId != null">
												<div class="form-group">
													<label for="">
														Relationship
														<span class="required">*</span>
													</label>
													<!-- Case 1: Standard countries — always use full RelationShipCollection -->
													<div class="mb-3" v-if="vModel.CountryId != 2 && vModel.CountryId != 3 && vModel.CountryId != 5 && vModel.CountryId != 6 && vModel.CountryId != 8 && vModel.CountryId != 9 && vModel.CountryId != 235 && vModel.CountryId != 123 && vModel.CountryId != 114">
														<select class="form-control" name="RelationShipId" ref="RelationShipDropDown" @change="onChangeRelationship"
																v-model="vModel.RelationShipId" v-validate="'required'"
																:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
															<option value="">Please Select Relationship</option>
															<option v-for="option in RelationShipCollection"
																	:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('RelationShipId')" class="help is-danger">
															{{ errors.first('RelationShipId') }}
														</div>
														<div v-show="showAdditionalRelationshipMessage" class="help is-danger">
															{{ additionalRelationshipMessage }}
														</div>
													</div>

													<!-- Case 2: Special countries + PayoutModeId != BankAccount — use full RelationShipCollection -->
													<div class="mb-3" v-if="(vModel.CountryId == 2 || vModel.CountryId == 5 || vModel.CountryId == 3 || vModel.CountryId == 6 || vModel.CountryId == 8 || vModel.CountryId == 9 || vModel.CountryId == 235 || vModel.CountryId == 123 || vModel.CountryId == 114) && vModel.PayoutModeId != 1">
														<select class="form-control" name="RelationShipId" ref="RelationShipDropDown" @change="onChangeRelationship"
																v-model="vModel.RelationShipId" v-validate="'required'"
																:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
															<option value="">Please Select Relationship</option>
															<option v-for="option in RelationShipCollection"
																	:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('RelationShipId')" class="help is-danger">
															{{ errors.first('RelationShipId') }}
														</div>
														<div v-show="showAdditionalRelationshipMessage" class="help is-danger">
															{{ additionalRelationshipMessage }}
														</div>
													</div>

													<!-- Case 3: Special countries + PayoutModeId == BankAccount — use FilteredRelationshipCollection -->
													<div class="mb-3" v-if="(vModel.CountryId == 2 || vModel.CountryId == 5 || vModel.CountryId == 3 || vModel.CountryId == 6 || vModel.CountryId == 8 || vModel.CountryId == 9 || vModel.CountryId == 235 || vModel.CountryId == 123 || vModel.CountryId == 114) && vModel.PayoutModeId == 1">
														<select class="form-control" name="RelationShipId" ref="RelationShipDropDown" @change="onChangeRelationship"
																v-model="vModel.RelationShipId" v-validate="'required'"
																:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
															<option value="">Please Select Relationship</option>
															<option v-for="option in FilteredRelationshipCollection"
																	:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="showAdditionalRelationshipMessage" class="help is-danger">
															{{ additionalRelationshipMessage }}
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId != 23 && vModel.CountryId != 123 && vModel.CountryId != 48 && vModel.CountryId != 251 && vModel.CountryId != 114)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="form-group">
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="18"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }">
														<div v-show="errors.has('MobileContact')" class="help is-danger">
															{{ errors.first('MobileContact') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 251 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text">+1</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="12"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile_aus'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>
													<div v-show="errors.has('MobileContact')" class="help is-danger"
														 v-html="errors.first('MobileContact')">
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 23 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text">+61</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="12"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile_aus'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>
													<div v-show="errors.has('MobileContact')" class="help is-danger"
														 v-html="errors.first('MobileContact')">
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 123 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text">+81</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="10"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:18|mobile_japan'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>
													<div v-show="errors.has('MobileContact')" class="help is-danger"
														 v-html="errors.first('MobileContact')">
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 114 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="input-group">
														<div class="input-group-prepend">
															<span class="input-group-text">+852</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="26"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|max:26|mobile_hongkong'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>
													<div v-show="errors.has('MobileContact')" class="help is-danger"
														 v-html="errors.first('MobileContact')">
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 48)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<div class="input-group">
														<div v-if="CambodiaMobilePrefixCollection.length > 1">
															<select class="form-control" name="TelcoMobileCodePrefix"
																	v-model="vModel.TelcoMobileCodePrefix" v-validate="'required'" :data-vv-as="'Telco mobile code'">
																<option value="">Select</option>
																<option v-for="prefixItem in CambodiaMobilePrefixCollection"
																		:key="prefixItem" :value="prefixItem">
																	{{prefixItem}}
																</option>
															</select>
														</div>
														<div v-else-if="CambodiaMobilePrefixCollection.length == 1">
															<input type="text" class="form-control" name="TelcoMobileCodePrefix"
																   autocomplete="off" readonly size="5"
																   v-model="vModel.TelcoMobileCodePrefix" />
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal="" maxlength="9" minlength="6"
															   v-model="vModel.MobileContact"
															   :data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
															   v-validate="'required|min:'+FieldValidation.MobileContact.MinLength+'|max:'+FieldValidation.MobileContact.MaxLength"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>
													<div v-show="errors.has('TelcoMobileCodePrefix')" class="help is-danger">
														{{ errors.first('TelcoMobileCodePrefix') }}
													</div>
													<div v-show="errors.has('MobileContact')" class="help is-danger">
														{{ errors.first('MobileContact') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.Email != null && vModel.CountryId == 23 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for="">
														Email
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control" name="Email"
														   autocomplete="off" v-model="vModel.Email"
														   :data-vv-as='FieldValidation.Email.WebRequiredMessage'
														   v-validate="'required|min:'+FieldValidation.Email.MinLength+'|max:'+FieldValidation.Email.MaxLength+'|email_aus'"
														   :class="{'input': true, 'is-danger': errors.has('Email') }" />
													<div v-show="errors.has('Email')" class="help is-danger">
														{{ errors.first('Email') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.NationalityId != null">
												<div class="form-group">
													<label for="">
														Nationality
														<span class="required">*</span>
													</label>

													<!--<kendo-dropdownlist v-if="NationalityCollection != null"
																			name='NationalityId' v-validate="'required'"
																			class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('NationalityId') }"
																			ref="nationalitydropdownlist" v-model="vModel.NationalityId"
																			:data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Nationality'" :auto-bind="true"
																			:data-source="NationalityCollection"
																			:data-value-primitive="true"
																			:data-vv-as="FieldValidation.NationalityId.WebRequiredMessage"
																			:disabled="FieldValidation.NationalityId.IsReadOnlyField">
														</kendo-dropdownlist>-->

													<kendo-dropdownlist v-if="NationalityCollection != null" :key="'nationality-' + vModel.ReceiverTypeId"
																		name="NationalityId"
																		v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('NationalityId') }"
																		ref="nationalitydropdownlist"
																		v-model="vModel.NationalityId"
																		:data-text-field="'Text'"
																		:data-value-field="'Id'"
																		:option-label="'Please Select Nationality'"
																		:auto-bind="true"
																		:data-source="NationalityCollection"
																		:data-value-primitive="true"
																		:data-vv-as="FieldValidation.NationalityId.WebRequiredMessage"
																		:disabled="FieldValidation.NationalityId.IsReadOnlyField">
													</kendo-dropdownlist>
													<div v-show="errors.has('NationalityId')" class="help is-danger">
														{{ errors.first('NationalityId') }}
													</div>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.HouseNo != null && FieldValidation.HouseNo.MinLength == null && FieldValidation.HouseNo.MaxLength == null">
												<div class="form-group">
													<label for="">
														House No./ Unit No.
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="HouseNo" autocomplete="off" v-model="vModel.HouseNo"
														   :data-vv-as='FieldValidation.HouseNo.WebRequiredMessage'
														   v-validate="'required|max:75'"
														   :class="{'input': true, 'is-danger': errors.has('HouseNo') }"
														   v-only-uppercase>
													<div v-show="errors.has('HouseNo')" class="help is-danger">
														{{ errors.first('HouseNo') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.HouseNo != null && FieldValidation.HouseNo.MinLength != null && FieldValidation.HouseNo.MaxLength != null">
												<div class="form-group">
													<label for="">
														House No./ Unit No.
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="HouseNo" autocomplete="off" v-model="vModel.HouseNo"
														   :data-vv-as='FieldValidation.HouseNo.WebRequiredMessage'
														   v-validate="'required|min:'+FieldValidation.HouseNo.MinLength+'|max:'+FieldValidation.HouseNo.MaxLength+'|House_No:'+FieldValidation.HouseNo.Regex.replace(',', '%')+','+FieldValidation.HouseNo.RegexMessage"
														   :class="{'input': true, 'is-danger': errors.has('HouseNo') }"
														   v-only-uppercase>
													<div v-show="errors.has('HouseNo')" class="help is-danger">
														{{ errors.first('HouseNo') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Address != null && FieldValidation.Address.MinLength != null && FieldValidation.Address.MaxLength != null  && ( vModel.ReceiverTypeId == 2 ||vModel.CountryId == 250)">
												<div class="form-group">
													<label for="">
														Address
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="Address" autocomplete="off" v-model="vModel.Address"
														   :data-vv-as='FieldValidation.Address.WebRequiredMessage'
														   :class="{'input': true, 'is-danger': errors.has('Address') }"
														   v-only-uppercase>
													<div v-show="errors.has('Address')" class="help is-danger">
														{{ errors.first('Address') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.StreetNo != null && FieldValidation.StreetNo.MinLength != null && FieldValidation.StreetNo.MaxLength != null">
												<div class="form-group">
													<label for="">
														Street Number
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   v-only-numeric="" name="StreetNo" autocomplete="off"
														   v-model="vModel.StreetNo"
														   :data-vv-as='FieldValidation.StreetNo.WebRequiredMessage'
														   v-validate="'required|min:'+FieldValidation.StreetNo.MinLength+'|max:'+FieldValidation.StreetNo.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('StreetNo') }"
														   v-only-uppercase>
													<div v-show="errors.has('StreetNo')" class="help is-danger">
														{{ errors.first('StreetNo') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MinLength == null && FieldValidation.Street.MaxLength == null">
												<div class="form-group">
													<label for="">
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street"
														   autocomplete="off" v-model="vModel.Street"
														   :data-vv-as='FieldValidation.Street.WebRequiredMessage'
														   v-validate="'required|max:75'"
														   :class="{'input': true, 'is-danger': errors.has('Street') }"
														   v-only-uppercase>
													<div v-show="errors.has('Street')" class="help is-danger">
														{{ errors.first('Street') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MinLength != null && FieldValidation.Street.MaxLength != null && vModel.CountryId != 250">
												<div class="form-group">
													<label for="">
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street"
														   autocomplete="off" v-model="vModel.Street"
														   :data-vv-as='FieldValidation.Street.WebRequiredMessage'
														   v-validate="'required|min:'+FieldValidation.Street.MinLength+'|max:'+FieldValidation.Street.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('Street') }"
														   v-only-uppercase>
													<div v-show="errors.has('Street')" class="help is-danger">
														{{ errors.first('Street') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MinLength != null && FieldValidation.Street.MaxLength != null && vModel.CountryId == 250">
												<div class="form-group">
													<label for="">
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street"
														   v-only-text-number="" autocomplete="off" v-model="vModel.Street"
														   :data-vv-as='FieldValidation.Street.WebRequiredMessage'
														   v-validate="'required|min:'+FieldValidation.Street.MinLength+'|max:'+FieldValidation.Street.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('Street') }"
														   v-only-uppercase>
													<div v-show="errors.has('Street')" class="help is-danger">
														{{ errors.first('Street') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.StreetTypeId != null">
												<div class="form-group">
													<label>
														Street Type
														<span class="required">*</span>
													</label>
													<select class="form-control" name="StreetTypeId"
															v-model="vModel.StreetTypeId" v-validate="'required'"
															:data-vv-as='FieldValidation.StreetTypeId.WebRequiredMessage'>
														<option value="">Please Select Street Type</option>
														<option v-for="option in StreetTypeCollection" :key="option.Id"
																:value="option.Id">
															{{option.Text}}
														</option>
													</select>
													<div v-show="errors.has('StreetTypeId')" class="help is-danger">
														{{ errors.first('StreetTypeId') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.PostCode != null">
												<div class="form-group" v-if="vModel.CountryId == 23">
													<label for="">
														Post Code
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" v-only-numeric
														   name="PostCode" autocomplete="off" v-model="vModel.PostCode"
														   :data-vv-as='FieldValidation.PostCode.WebRequiredMessage'
														   v-validate="vModel.CountryId == 251 ? 'required' : vModel.CountryId == 123 ? 'required|JapanPostCode' : vModel.CountryId == 23 ? 'required|AusPostCode' : 'required:max:50'"
														   :class="{'input': true, 'is-danger': errors.has('PostCode') }">
													<div v-show="errors.has('PostCode')" class="help is-danger">
														{{ errors.first('PostCode') }}
													</div>
												</div>
												<div class="form-group" v-else>
													<label for="">
														Post Code
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="PostCode" autocomplete="off" v-model="vModel.PostCode"
														   :data-vv-as='FieldValidation.PostCode.WebRequiredMessage'
														   v-validate="vModel.CountryId == 251 ? 'required' : vModel.CountryId == 123 ? 'required|JapanPostCode' : vModel.CountryId == 23 ? 'required|AusPostCode' : 'required:max:50'"
														   :class="{'input': true, 'is-danger': errors.has('PostCode') }"
														   v-only-uppercase>
													<div v-show="errors.has('PostCode')" class="help is-danger">
														{{ errors.first('PostCode') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.City != null">
												<div class="form-group">
													<label for="">
														City
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="City"
														   autocomplete="off" v-model="vModel.City"
														   :data-vv-as='FieldValidation.City.WebRequiredMessage'
														   v-validate="'required|min:3|max:50'"
														   :class="{'input': true, 'is-danger': errors.has('City') }"
														   v-only-uppercase>
													<div v-show="errors.has('City')" class="help is-danger">
														{{ errors.first('City') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.StateId != null">
												<div class="form-group">
													<label>
														State
														<span class="required">*</span>
													</label>
													<select class="form-control" name="StateId" v-model="vModel.StateId"
															v-validate="'required'"
															:data-vv-as='FieldValidation.StateId.WebRequiredMessage'
															@change="onChangeState">
														<option value="">Please Select State</option>
														<option v-for="option in StatesCollection" :key="option.Id"
																:value="option.Id">
															{{option.Text}}
														</option>
													</select>
													<div v-show="errors.has('StateId')" class="help is-danger">
														{{ errors.first('StateId') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.StateName != null">
												<div class="form-group">
													<label for="">
														State
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="StateName" autocomplete="off" v-model="vModel.StateName"
														   :data-vv-as='FieldValidation.StateName.WebRequiredMessage'
														   v-validate="'required'"
														   :class="{'input': true, 'is-danger': errors.has('StateName') }"
														   v-only-uppercase>
													<div v-show="errors.has('StateName')" class="help is-danger">
														{{ errors.first('StateName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.CityId != null">
												<div class="form-group">
													<label>
														City
														<span class="required">*</span>
													</label>
													<select class="form-control" name="CityId" v-model="vModel.CityId"
															v-validate="'required'"
															:data-vv-as='FieldValidation.CityId.WebRequiredMessage'>
														<option value="">Please Select City</option>
														<option v-for="option in CitiesCollection" :key="option.Id"
																:value="option.Id">
															{{option.Text}}
														</option>
													</select>
													<div v-show="errors.has('CityId')" class="help is-danger">
														{{ errors.first('CityId') }}
													</div>
												</div>
											</div>
										</div>

										<!-- In case Of Indonessia -->
										<div class="row" v-if="vModel.PayoutModeId == 2 && vModel.CountryId == 3">
											<div class="col-lg-12">
												<label>
													<font color='red'>
														Note: <br />
														Receivers Address must be the same as the address that appears
														in your receivers Indonesian
														National Id (Kartu Tanda Penduduk - KTP)
													</font>
												</label>
											</div>
										</div>

										<div class="row">
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 5 && vModel.PayoutModeId == 31">
												<div class="form-group">

													<div>
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="50"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 5 && vModel.PayoutModeId == 31 && IsAccountValidationRequired">
												<button class="btn red-btn" @click="ValidateCommonwalletnumber()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 10 && (vModel.PayoutModeId == 32 || vModel.PayoutModeId == 33)">
												<div class="form-group">

													<div>
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="50"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 10 && (vModel.PayoutModeId == 32 || vModel.PayoutModeId == 33) && IsAccountValidationRequired">
												<button class="btn red-btn" @click="ValidateCommonwalletnumber()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 1 && (vModel.PayoutModeId == 23 ||vModel.PayoutModeId == 30)">
												<div class="form-group">

													<div>
														<label>
															{{vModel.PayoutModeId ==23 ? "bKash Wallet Number" :"eWallet Number"}}
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group" v-if="vModel.PayoutModeId == 23">
														<div class="input-group-prepend"><span class="input-group-text" style="color:#000;"><span>+88 </span></span></div>

														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="11"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div class="input-group" v-if="vModel.PayoutModeId == 30">
														<div class="input-group-prepend">
															<span class="input-group-text" style="color:#000;">
																<span>+88 </span>
															</span>
														</div>

														<input type="text"
															   class="form-control text-uppercase"
															   name="AccountNumber"
															   autocomplete="off"
															   v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric
															   maxlength="11"
															   v-validate="'required|min:11|max:11'"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>

													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 1 && vModel.PayoutModeId == 23 && IsAccountValidationRequired">
												<button class="btn red-btn" @click="verifybKash()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<!-- MCB Wallet Number BEGIN -->
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 7 && vModel.PayoutModeId == 26">
												<div class="form-group">

													<div>
														<label>
															MCB Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off" v-mask="accountMask"
														   v-model="vModel.AccountNumber"
														   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
														   v-only-numeric='' maxlength="15"
														   v-validate="'required|BankAccount:'+vModel.CountryId"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>


													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 7 && vModel.PayoutModeId == 26">
												<button class="btn red-btn" @click="verifyMCB()" :disabled="IsMCBVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<!-- MCB Wallet Number END -->
											<div class="col-lg-4"
												 v-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && !accountNoValidation.IsAccValidationActive">
												<div class="form-group">
													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>
													<div v-if="vModel.CountryId == 131">
														<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-validate="'required|account_format'"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>
													<div v-else>
														<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-text-number='' maxlength="30"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>

													<div v-show="errors.has('AccountNumber')" class="help is-danger" v-html="errors.first('AccountNumber')">
													</div>

												</div>
											</div>

											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 3 && vModel.PayoutModeId == 1 && this.IsAccountValidationRequired">
												<button class="btn red-btn" @click="verifyIndonesiaBankAccount()" :disabled="IsIndonesiaVerify"
														type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>

											<div class="col-lg-4"
												 v-else-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && accountNoValidation.IsAccValidationActive">
												<div class="form-group" v-if='accountNoValidation.Type == "ALPHANUMERIC"'>

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
														   name="AccountNumber" autocomplete="off"
														   data-vv-as="Account Number"
														   v-model="vModel.AccountNumber"
														   v-only-text-number
														   :maxlength="accountNoValidation.MaxLength"
														   v-validate="'required|BankAccount_Validation:'+vModel.CountryId+','+accountNoValidation.RequiredMessage + ','+accountNoValidation.Type + ','+accountNoValidation.MinLength + ','+accountNoValidation.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>
												<div class="form-group" v-else>

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off"
														   data-vv-as="Account Number"
														   v-model="vModel.AccountNumber"
														   v-only-numeric
														   :maxlength="accountNoValidation.MaxLength"
														   v-validate="'required|BankAccount_Validation:'+vModel.CountryId+','+accountNoValidation.RequiredMessage + ','+accountNoValidation.Type + ','+accountNoValidation.MinLength + ','+accountNoValidation.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>
											</div>

											<div class="col-lg-4"
												 v-if="vModel.CountryId == 56 && vModel.PayoutModeId == 22">
												<div class="form-group">
													<div>
														<label>
															Receiver Name
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   :disabled="true" name="WalletName" autocomplete="off"
														   v-model="walletName" :class="{'input': true}">
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 22">
												<div class="form-group">
													<div v-if="vModel.CountryId == 56 && vModel.PayoutModeId == 22">
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control" name="AccountNumber" @input="DeActivateSaveButton"
														   autocomplete="off" v-model="vModel.AccountNumber"
														   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
														   maxlength="64" v-validate="'required'"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }">
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 21">
												<div class="form-group">
													<div>
														<label>
															UnionPay Card Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off"
														   v-model="vModel.AccountNumber"
														   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
														   v-only-text-number='' maxlength="30"
														   v-validate="'required|BankAccount:'+vModel.CountryId"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger"
														 v-html="errors.first('AccountNumber')">
													</div>
												</div>
											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 56 && vModel.PayoutModeId == 21  && vModel.PayoutGroupName != 'UNIONPAY THUNES'">
												<button class="btn red-btn" @click="verifyUnionpay()" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ABNNumber != null && vModel.PayoutModeId == 1 && vModel.CountryId == 23 && vModel.ReceiverTypeId == 2">
												<div class="form-group">

													<div>
														<label>
															ABN No
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="ABNNumber" autocomplete="off"
														   maxlength="50"
														   v-validate="'required|max:'+FieldValidation.ABNNumber.MaxLength"
														   :data-vv-as='FieldValidation.ABNNumber.WebRequiredMessage'
														   v-model="vModel.ABNNumber"
														   v-only-text-number
														   :class="{'input': true, 'is-danger': errors.has('ABNNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('ABNNumber')" class="help is-danger">
														{{ errors.first('ABNNumber') }}
													</div>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.CompanyTypeId != null && vModel.PayoutModeId == 1 && (vModel.CountryId == 23 || vModel.CountryId == 251) && vModel.ReceiverTypeId == 2">
												<div class="form-group">

													<div>
														<label>
															Company Type
															<span class="required">*</span>
														</label>
													</div>
													<kendo-dropdownlist v-if="CompanyTypeCollection != null"
																		name='CompanyType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('CompanyType') }"
																		ref="companytypedropdownlist" v-model="vModel.CompanyTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Company Type'" :auto-bind="true"
																		:data-source="CompanyTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'"
																		@change="onChangeCompanyTypeDropDown"
																		:data-vv-as='FieldValidation.CompanyTypeId.WebRequiredMessage'
																		@dataBound="onCompanyTypeDropDownBound">
													</kendo-dropdownlist>
													<div v-show="errors.has('CompanyType')" class="help is-danger">
														{{ errors.first('CompanyType') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverIdTypeId != null && ((vModel.PayoutModeId == 21 && vModel.CountryId == 56 && vModel.PayoutGroupName == 'UNIONPAY THUNES') || ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10))">
												<div class="form-group">

													<div>
														<label>
															Receiver ID Type
															<span class="required">*</span>
														</label>
													</div>
													<kendo-dropdownlist v-if="ReceiverIdTypeCollection != null"
																		name='IdType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('ReceiverIdType') }"
																		ref="idtypedropdownlist" v-model="vModel.ReceiverIdTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Id Type'" :auto-bind="true"
																		:data-source="ReceiverIdTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'">
													</kendo-dropdownlist>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverIdNumber != null && ((vModel.PayoutModeId == 21 && vModel.CountryId == 56 && vModel.PayoutGroupName == 'UNIONPAY THUNES') || ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10))">
												<div class="form-group">

													<div>
														<label>
															Receiver ID Number
															<span class="required">*</span>
														</label>
													</div>
													<input type="text" class="form-control text-uppercase"
														   name="ReceiverIdNumber" autocomplete="off" v-mask="accountMask"
														   v-model="vModel.ReceiverIdNumber"
														   v-only-text-number='' maxlength="30"
														   v-validate="'required'"
														   :class="{'input': true, 'is-danger': errors.has('ReceiverIdNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('ReceiverIdNumber')" class="help is-danger" v-html="errors.first('ReceiverIdNumber')">
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverDateOfBirth != null && ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10)">
												<div class="form-group">
													<div>
														<label>
															Date Of Birth
															<span class="required">*</span>
														</label>
													</div>
													<kendo-datepicker class="form-control" :format="'dd/MM/yyyy'"
																	  id="dobirth"
																	  name="dobirth"
																	  v-model="vModel.ReceiverDateOfBirth"
																	  data-vv-as='Date Of Birth'
																	  v-validate="'required'"
																	  onkeydown="return false;"
																	  :class="{'input': true, 'is-danger': errors.has('dobirth') }"
																	  ref="ReceiverDateOfBirth">
													</kendo-datepicker>
												</div>
											</div>
										</div>

										<div class="row" v-show="IsValidBkashNumber">
											<div class="col-lg-12">
												<label>
													<strong>Result</strong><br>
													<strong>Receiver's Name : {{this.BkashReceiverName}}</strong>
												</label>
											</div>
										</div>
										<div class="row" v-show="IsUnionpayVerify">
											<div class="col-lg-12">
												<label>
													<strong>Result</strong><br>
													<strong>Validation : {{IsValidUnionpayCardNumber ? "Success" : "Failed"}}</strong>
												</label>
											</div>
										</div>
										<div class="row" v-show="IsValidIndonesiaAccNumber">
											<div class="col-lg-12">
												<label>
													<strong>Result</strong><br>
													<strong>Receiver's Name : {{this.IndonesiaAccountReceiverName}}</strong>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 21 && vModel.CountryId == 56">
											<div class="col-lg-12">
												<label>
													<font color='red'>
														Note: <br />
														Only China Union Pay Debit Card number starting with 6, 62,
														955880, 955882 or 955888 are supported.
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 22 && vModel.CountryId == 56"
											 style="display: none;">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">1. Receivers Alipay Wallet must be registered in China.</font></pre>
													<pre class="note"><font color="red">2. Receivers name must match the name registered with Alipay Wallet.</font></pre>
													<pre class="note"><font color="red">3. Funds will be credited to the receiver’s bank account linked to the Wallet.</font></pre>

												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 23 && vModel.CountryId == 1">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">Receiver's Name must be exactly the same as the displayed name above.</font></pre>

												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 1 && vModel.CountryId == 3 && this.IsAccountValidationRequired">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">Receiver's Name must be exactly the same as the displayed name above.</font></pre>

												</label>
											</div>
										</div>
										<div class="row"
											 v-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && FieldValidation.AccountNumber.Note">
											<div class="col-lg-12">
												<label>
													<font color='red'>
														Note: <br />
														{{FieldValidation.AccountNumber.Note}}
													</font>
												</label>
											</div>
										</div>
										<div class="row"
											 v-if="FieldValidation != null && FieldValidation.NationalityId != null && FieldValidation.NationalityId.Note">
											<div class="col-lg-12">
												<label>
													<font color='red'>
														Note: <br />
														{{FieldValidation.NationalityId.Note}}
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="showB2BMessage">
											<div class="col-lg-12">
												<label for="">
													<font color="red">
														Note: <br />
														Sending money to corporates is not permitted. Please sign up at <a target="_blank" href="https://www.bizpayments.com.my/">https://www.bizpayments.com.my/</a> for corporate transactions.
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.CountryId == 250">
											<div class="col-lg-12">
												<label for="">
													<font color="red">
														Note: <br />
														United Kingdom Account Number format should be Sort Code (6 Digits) + Account No (8-10 Digits) i.e xxxxxx-xxxxxxxxxx <a target="_blank" href="https://www.sortcodes.co.uk/">UK SortCode Link</a>
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 1 && vModel.CountryId == 131">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">South Korea's bank account number format should be Bank Code (3 Digits) + Branch Code (3 to 4 Digits) + Account No (6 to 9 Digits)</font></pre>
													<pre class="note"><font color="red">i.e. xxx-xxxx-xxxxxxx</font></pre>

												</label>
											</div>
										</div>
									</div>

									<div class="submit-option">
										<div class="left-option">
											<router-link :to="'/recipient/merchantrade'" class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="material-icons">chevron_left</i>
												</span>
												<span class="btn-content">Cancel</span>
											</router-link>
										</div>
										<div class="right-option">
											<button class="btn submit-righticon-btn" :disabled="(IsBkashBtnDisabled && IsAccountValidationRequired) || IsWingWalletBtnDisabled || IsMCBBtnDisabled || IsWeixinWalletBtnDisabled || IsUnionpayBtnDisabled || (IsIndonesiaBankAccBtnDisabled && IsAccountValidationRequired)||(IsBtnDisabledforWallet && IsAccountValidationRequired)">
												<span class="btn-content">Create</span>
												<span class="right-icon">
													<i class="material-icons">chevron_right</i>
												</span>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import ListService from "../../services/list";
	import TransactionService from "../../services/transaction";
	import FormGenerator from "../../formcomponents/FormGenerator.vue";
	import CommonService from "../../services/common";

	import vSelect from 'vue-select'
	Vue.component('v-select', vSelect)

	import VueMask from "v-mask";
	Vue.use(VueMask);

	import {
		vueinstance
	} from "../../main";
	import {
		_
	} from 'vue-underscore';

	export default {
		name: "WesterUnion",
		extends: Base,
		components: {
			Action,
			Mode,
			FormGenerator,
		},
		created() {
			this.url.addWesternUnion = "recipient/westernunion/save";
			this.url.addMerchantrade = "recipient/merchantrade/save";
			this.url.addVisaDirect = "recipient/visadirect/save";
		},
		beforeRouteEnter(to, from, next) {
			var promises = [ListService.get("list/countrypaymentnetwork"),
			//ListService.get("list/westernunion/statebycountryid/251"),
			//ListService.get("list/westernunion/statebycountryid/159"),
			//ListService.get("list/relationship"),
			ListService.getNationality(),
			];

			Promise.all(promises).then(response => {
				next(p => {
					p.CountryCollection = response[0].body;
					p.AllCountryList = [...p.CountryCollection];
					console.log(p.AllCountryList);
					//p.USStates = response[1].body;
					//p.MexicoStates = response[2].body;
					//p.RelationShipCollection = response[1].body;
					p.NationalityCollection = response[1].body;
				});
			});

		},
		data() {
			return {
				accountNoValidation: {
					RequiredMessage: "",
					Type: "",
					MaxLength: 0,
					MinLength: 0,
					IsAccValidationActive: false
				},
				itemTemplate: '<img src="#:data.Icon#" height="25" width="25">&nbsp;<span>#:data.Name#</span>',
				showB2BMessage: false,
				additionalRelationshipCollection: ["7", "8", "15", "16", "17"],
				showAdditionalRelationshipMessage: false,
				additionalRelationshipMessage: `3rd party relationship selected. On behalf, details will be required during the transaction.`,
				b2BCountryList: ["8", "3", "250", "2", "6", "235", "9", "23"],
				CountryCollection: null,
				CurrencyCollection: [],
				PaymentMethods: [],
				StatesCollection: [],
				OccupationCollection: [],
				RelationShipCollection: [],
				PaymentNetworkCollection: [],
				NationalityCollection: [],
				MexicoStates: [],
				USStates: [],
				IsSetupOne: true,
				MexicoCities: [],
				CitiesCollection: [],
				StreetTypeCollection: [],
				CambodiaMobilePrefixCollection: [],
				ReceiverTypeCollection: [
					{
						Id: 1,
						Text: "Personal",
					},
					{
						Id: 2,
						Text: "Business"
					}],
				AccountTypeCollection: [
					{
						Id: 1,
						Text: "Savings",
					},
					{
						Id: 2,
						Text: "Checking"
					}],
				CompanyTypeCollection: [],
				PayoutGroupCollection: [],
				//ReceiverIdTypeCollection: [
				//	{
				//		Id: 1,
				//		Text: "MyKad",
				//	},
				//	{
				//		Id: 4,
				//		Text: "Passport"
				//	}
				//],
				ReceiverIdTypeCollection: [],
				vModel: {
					Id: null,
					CountryId: '',
					CountryName: '',
					CurrencyId: '',
					Currency: '',
					CountryName: '',
					PaymentNetworkId: '',
					PaymentNetworkName: '',
					PaymentNetworkIcon: '',
					PayoutModeId: '',
					PayoutModeName: '',
					Currency: '',
					FirstName: '',
					MiddleName: '',
					LastName: '',
					RelationShipId: null,
					MobileContact: '',
					Street: '',
					PostCode: '',
					StateName: '',
					StateId: null,
					CityName: '',
					CityId: '',
					OccupationId: '',
					RelationShipId: '',
					CurrencyName: '',
					CurrencyCode: '',
					FlagCode: null,
					BankId: null,
					BranchId: null,
					Address: null,
					AccountNumber: null,
					City: null,
					StateId: '',
					AgentId: null,
					StateName: null,
					BranchCode: null,
					IsNationalIDOld: false,
					NationalId: null,
					AccountInfo: null,
					AccountName: null,
					BankInfo: null,
					PayModeName: null,
					BranchName: null,
					BranchAddress: null,
					HouseNo: null,
					NationalityId: null,
					StreetTypeId: '',
					StreetNo: null,
					CountryCode: '',
					Email: '',
					WingWalletNumber: '',
					WeixinWalletNumber: '',
					TelcoMobileCodePrefix: '',
					PayoutGroupName: '',
					ReceiverIdTypeId:'',
					ReceiverIdNumber: '',
					CompanyName: '',
					AccountPrefix:null,
					WalletTypeId: null,
					ReceiverDateOfBirth: null,
				},
				D2BData: {},
				schema: [],
				bankSection: [],
				recipientSection: [],
				Remarks: null,
				Note: null,
				BankCollection: null,
				WalletTypeCollection: null,
				AccountPrefix: null,
				BranchCollection: null,
				AgentCollection: null,
				IfscCode: null,
				optionBranches: [],
				selectedBranch: null,
				FieldValidation: null,
				AllBanksList: null,
				AllCountryList: null,
				IsBkashBtnDisabled: false,
				IsBtnDisabledforWallet: false,
				IsValidBkashNumber: false,
				IsMCBBtnDisabled: false,
				IsWeixinWalletBtnDisabled: false,
				IsValidMCBNumber: false,
				IsWingWalletBtnDisabled: false,
				IsValidWingWalletNumber: false,
				IsValidIndonesiaAccNumber: false,
				IsIndonesiaBankAccBtnDisabled: false,
				IsValidWeixinWalletNumber: false,
				IsWingWalletValidationChecked: false,
				IsWeixinWalletValidationChecked: false,
				IsBkashVerify: false,
				IsMCBVerify: false,
				IsIndonesiaVerify: false,
				BKashFirstName: null,
				BkashLastName: null,
				MCBFirstName: null,
				MCBLastName: null,
				IndonesiaAccountFirstName: null,
				IndonesiaAccountLastName: null,
				WingWalletFullName: null,
				WingWalletCurrency: null,
				WeixinWalletFullName: null,
				WeixinWalletCurrency: null,
				ShowBkashNameMismatchPopup: false,
				ShowWalletMismatchPopup: false,
				ShowMCBNameMismatchPopup: false,
				ShowIndonesiaAccountMismatchPopup: false,
				IsValidUnionpayCardNumber: false,
				IsUnionpayBtnDisabled: false,
				IsUnionpayVerify: false,
				CarryModel: {
					PaymentNetworkId: 0,
					CountryId: 0,
					PaymentModeId: 0,
					PayoutCurrencyId: 0,
					SendAmount: 0,
					PayAmount: 0,
					IsLocalCurrencyKeyIn: false,
					IsStepOne: false
				},
				IsWingWalletVerify: false,
				IsWeixinWalletVerify: false,
				GroupCode: null,
				IsAccountValidationRequired: true,
				IsPrefixAvaliable: false,
				showGcashAccountPrefix: false,
				ShowReceiverTypePopup: false,
				PendingReceiverFullName: ''
			};
		},

		watch: {
			"selectedBranch": function (newValue, oldValue) {
				if (newValue != null) {
					this.vModel.BranchId = newValue.Id;
					this.vModel.BranchCode = newValue.BranchCode;
					this.IfscCode = null;

				} else if (newValue == null && this.IfscCode != null) {
					this.vModel.BranchId = null;
					this.IfscCode = null;
				} else {
					this.vModel.BranchId = null;
					this.vModel.BranchCode = null;
					this.IfscCode = null;
				}


				}
		},

		computed: {
			accountMask: function () {
				if (this.vModel.PaymentNetworkId == 1) {
					if (this.vModel.CountryId == "23") return "######-#########";
					else if (this.vModel.CountryId == "172") return "##-####-#######-###";
					else if (this.vModel.CountryId == "250") return "######-##########";
					else if (this.vModel.CountryId == "251")
						return "#########-#################";
					else return "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
				}
			},
			fullname: function () {
				if (this.vModel.FirstName == null) this.vModel.FirstName = "";

				if (this.vModel.MiddleName == null) this.vModel.MiddleName = "";

				if (this.vModel.LastName == null) this.vModel.LastName = "";

				return (
					this.vModel.FirstName.trim() +
					this.vModel.MiddleName.trim() +
					this.vModel.LastName.trim()
				);
			},

			walletName: function () {
				if (this.vModel.PayoutModeId == 22) {
					return (`${this.vModel.FirstName} ${this.vModel.LastName}`)
				}
			}

		},
		mounted: function () {
			this.$nextTick(function () {
				this.CarryModel = CommonService.getStorage("carryModel");
				CommonService.removeStorage("carryModel");
				if (this.CarryModel.IsStepOne) {
					this.vModel.CountryId = this.CarryModel.CountryId;

					// set paymentNetwork
					var selectedCountry = this.CountryCollection.filter(p => {
						return p.Id == this.vModel.CountryId;
					})[0];

					this.vModel.CountryName = selectedCountry.Text;
					this.vModel.FlagCode = selectedCountry.FlagCode;
					this.vModel.CountryCode = selectedCountry.Code;
					this.PaymentNetworkCollection = selectedCountry.PaymentNetworks.filter(x => {
						return x.IsActive == true
					});

					this.$refs.paymentnetworkdropdownlist.kendoWidget()
						.setDataSource(this.PaymentNetworkCollection);

					this.vModel.PaymentNetworkId = this.CarryModel.PaymentNetworkId;

					//set PaymentMethod
					var selectedPaymentNetwork = this.PaymentNetworkCollection.filter(p => {
						return p.Id == this.vModel.PaymentNetworkId;
					})[0];

					this.vModel.PaymentNetworkName = selectedPaymentNetwork.Name;
					this.vModel.PaymentNetworkIcon = selectedPaymentNetwork.Icon
					this.PaymentMethods = selectedPaymentNetwork.PayoutModes;
					this.vModel.PayoutModeId = this.CarryModel.PaymentModeId;
					var selectedPayment = selectedPaymentNetwork.PayoutModes.filter(p => {
						return p.Id == this.vModel.PayoutModeId;
					})[0];

					this.vModel.PayoutModeName = selectedPayment.Text;

					//set currency
					if (this.vModel.PaymentNetworkId == 1 || this.vModel.PaymentNetworkId == 2 || this.vModel.PaymentNetworkId == 3) {
						if (this.vModel.PaymentNetworkId == 3) {
							this.CurrencyCollection = selectedPayment.VDCurrencies;
						}
						else if (this.vModel.PaymentNetworkId == 2) {
							this.CurrencyCollection = selectedPayment.Currencies;
						}
						else if (this.vModel.PaymentNetworkId == 1) {
							if (this.vModel.CountryName == 'Cambodia') {
								this.CurrencyCollection = selectedPayment.MIRSCurrencies;
							}
						}
						this.vModel.CurrencyId = this.CarryModel.PayoutCurrencyId;

						var selectedCurrency = this.CurrencyCollection.filter(p => {
							return p.Id == this.vModel.CurrencyId;
						})[0];
						this.vModel.CurrencyName = selectedCurrency.Text;
					}
				}
			})
		},
		methods: {

			onChangeState() {
				this.vModel.City = '';
				this.vModel.CityId = '';
				var selectedState = "";
				if (this.vModel.CountryId == '159' && this.vModel.StateId != '') {

					selectedState = this.StatesCollection.filter(p => {
						return p.Id == this.vModel.StateId;
					})[0];

					this.MexicoCities = selectedState.Cities;
				}
				if (this.vModel.CountryId == '23' && this.vModel.PayoutModeId == '1' && this.vModel.StateId != '') {

					selectedState = this.StatesCollection.filter(p => {
						return p.Id == this.vModel.StateId;
					})[0];

					this.CitiesCollection = selectedState.Cities;
				}
			},
			onChangeCurrency() {
				if (this.vModel.CurrencyId != '') {

					var selectedCurrency = this.CurrencyCollection.filter(p => {
						return p.Id == this.vModel.CurrencyId;
					})[0];

					this.vModel.CurrencyName = selectedCurrency.Text;
					this.vModel.CurrencyCode = selectedCurrency.Code;
					if (this.vModel.PayoutModeId == "98") {
						ListService.get("recipient/westernunion/d2bform/" + this.vModel.CountryCode + "/" + selectedCurrency.Code).then(res => {
							this.D2BData = JSON.parse(res.body.D2BData);
							this.schema = res.body.schema;
							this.bankSection = res.body.schema.BankDetails
							this.recipientSection = res.body.schema.PersonalDetails

						});
					}
				}
			},

			onChangeDeliveryOption() {
				this.CurrencyCollection = [];
				this.vModel.CurrencyId = '';

				if (this.vModel.PayoutModeId != '') {
					var selectedCountry = this.CountryCollection.filter(p => {
						return p.Id == this.vModel.CountryId;
					})[0];

					var selectedPaymentNetwork = this.PaymentNetworkCollection.filter(p => {
						return p.Id == this.vModel.PaymentNetworkId
					})[0];

					var selectedPayment = selectedPaymentNetwork.PayoutModes.filter(p => {
						return p.Id == this.vModel.PayoutModeId;
					})[0];

					this.vModel.PayoutModeName = selectedPayment.Text;
					if (this.vModel.PaymentNetworkId == 3) {
						this.CurrencyCollection = selectedPayment.VDCurrencies;
					}
					else if (this.vModel.PaymentNetworkId == 2) {
						this.CurrencyCollection = selectedPayment.Currencies;
					}
					else if (this.vModel.PaymentNetworkId == 1) {
						if (this.vModel.CountryName == 'Cambodia') {
							this.CurrencyCollection = selectedPayment.MIRSCurrencies;
						}
						if (this.vModel.CountryName == 'China' && this.vModel.PayoutModeName == 'Union Pay Card') {
							this.PayoutGroupCollection = selectedPayment.PayoutGroups;
						}
					}
				}
			},

			onChangeCountry: function () {
				this.CurrencyCollection = [];
				this.PaymentMethods = [];
				this.StatesCollection = [];
				this.PaymentNetworkCollection = [];
				this.schema = [];

				this.vModel.CurrencyId = '';
				this.vModel.PayoutModeId = '';
				this.vModel.PaymentNetworkId = '';

				var dropDownList = this.$refs.countrydropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				this.vModel.CountryId = selectedVlaue;


				if (selectedVlaue) {

					var selectedCountry = this.CountryCollection.filter(p => {
						return p.Id == selectedVlaue;
					})[0];

					this.vModel.CountryName = selectedCountry.Text;
					this.vModel.FlagCode = selectedCountry.FlagCode;
					this.vModel.CountryCode = selectedCountry.Code;

					this.PaymentNetworkCollection = selectedCountry.PaymentNetworks.filter(x => {
						return x.IsActive == true
					});

					this.$refs.paymentnetworkdropdownlist.kendoWidget()
						.setDataSource(this.PaymentNetworkCollection);

				}

			},

			onChangePaymentNetwork: function () {
				this.CurrencyCollection = [];
				this.PaymentMethods = [];
				this.StatesCollection = [];

				this.vModel.CurrencyId = '';
				this.vModel.PayoutModeId = '';

				var dropDownList = this.$refs.paymentnetworkdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				this.vModel.PaymentNetworkId = selectedVlaue;

				if (selectedVlaue) {
					var selectedPaymentNetwork = this.PaymentNetworkCollection.filter(p => {
						return p.Id == selectedVlaue;
					})[0];

					this.vModel.PaymentNetworkName = selectedPaymentNetwork.Name;
					this.vModel.PaymentNetworkIcon = selectedPaymentNetwork.Icon
					this.PaymentMethods = selectedPaymentNetwork.PayoutModes;

					// if (selectedVlaue == 1 && this.b2BCountryList.includes(this.vModel.CountryId))
					// 	this.showB2BMessage = true;
				}

			},
			onChangeReceiverType: function () {
				var dropDownList = this.$refs.receivertypedropdownlist.kendoWidget();
				var selectedReceiverTypeId = dropDownList.value();

				if (selectedReceiverTypeId) {
					if (selectedReceiverTypeId == 1) {
						this.vModel.CompanyName = '';						
					}
					else if (selectedReceiverTypeId == 2) {
						this.vModel.FirstName = '';
						this.vModel.LastName = '';
						this.vModel.CompanyTypeId = '';
					}
					
						  if (this.RelationShipCollection && this.RelationShipCollection.length > 0) {
							this.FilteredRelationshipCollection = this.RelationShipCollection.filter(item => 
								item.ReceiverTypeId == selectedReceiverTypeId
							);
							console.log('Relationship Colletcion',this.RelationShipCollection);
                console.log('Filtered Collection',this.FilteredRelationshipCollection);
							// Get the Kendo dropdown widget
							var relationshipDropdown = this.$refs.indiaRelationshipDropDownlist;
							if (relationshipDropdown && relationshipDropdown.kendoWidget) {
								relationshipDropdown.kendoWidget()
									.setDataSource(this.FilteredRelationshipCollection);
							}
						}
					
				}
			},

			onChangePayoutGroup: function () {
				var dropDownList = this.$refs.payoutagentdropdownlist.kendoWidget();
				var selectedText = dropDownList.text();

				if (selectedText) {
					this.vModel.PayoutGroupName = selectedText;
				}
			},
			onSubmit: function () {
				this.$validator.validateAll().then(result => {
					if (result) {
						if (this.IsSetupOne) {
							if (this.vModel.PaymentNetworkId == "1") {
								this.getNextFormData();
								this.IsSetupOne = false;
							} else {
								var promises = [];
								promises.push(ListService.getFeildValidate(this.vModel.CountryId, this.vModel
									.PayoutModeId));
								promises.push(ListService.getById("list/westernunion/statebycountryid/" + this
									.vModel.CountryId));
								promises.push(ListService.getRelationship(this.vModel.PayoutModeId, this.vModel.CountryId));

								Promise.all(promises).then(response => {
									if (response[0].body) {
										this.FieldValidation = response[0].body;
										this.IsSetupOne = false;
									}
									if (response[1].body) {
										this.StatesCollection = response[1].body;
									}
									if (response[2].body)
										this.RelationShipCollection = response[2].body;
								});
							}

						} else {
							if (this.isProcessing)
								return;
							this.isProcessing = true;

							var url = "";
							if (this.vModel.PaymentNetworkId == "1") {
								url = this.url.addMerchantrade;
							} else if (this.vModel.PaymentNetworkId == "2") {
								url = this.url.addWesternUnion;
							} else if (this.vModel.PaymentNetworkId == "3") {
								url = this.url.addVisaDirect;
							}
							var post = Object.assign({}, this.vModel);
							if (this.vModel.CountryId == 251 && this.vModel.PayoutModeId == 1)
								post.MobileContact = `+1${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 23 && this.vModel.PayoutModeId == 1)
								post.MobileContact = `+61${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 123 && this.vModel.PayoutModeId == 1)
								post.MobileContact = `+81${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 114 && this.vModel.PayoutModeId == 1)  //Hong Kong
								post.MobileContact = `+852${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 1 && (this.vModel.PayoutModeId == 23 || this.vModel.PayoutModeId == 30 ))
								post.AccountNumber = `+88${this.vModel.AccountNumber}`;
							if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 27)
								post.AccountNumber = `+${this.vModel.AccountNumber}`;
							if (this.vModel.CountryId == 48 && this.vModel.PayoutModeId == 1) {
								post.CurrencyId = this.vModel.CurrencyId;
							}
							if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 21) {
								post.AgentId = this.vModel.AgentId;
							}
							if(this.vModel.CountryId==3 && this.vModel.PayoutModeId ==28){
								if(this.vModel.AccountPrefix !=undefined)
									post.AccountNumber = this.vModel.AccountPrefix + this.vModel.AccountNumber;
							}
							if (this.vModel.CountryId == 6 && this.vModel.PayoutModeId == 24 && this.vModel.BankName.toUpperCase() == 'GCASH') {
								post.AccountPrefix = "09";
								post.AccountNumber = "09" + this.vModel.AccountNumber;
							}
							post["D2BData"] = JSON.stringify(this.D2BData);
							delete post.schema;

							const routes =
							{
								"1": "/recipient/merchantrade",
								"2": "/recipient/westernunion",
								"3": "/recipient/visadirect"
							};
							const route = routes[this.vModel.PaymentNetworkId] || routes["1"];

							if (this.vModel.PayoutModeId == 22) {

								TransactionService.validateAlipay({
									FirstName: this.vModel.FirstName,
									LastName: this.vModel.LastName,
									AccountNumber: this.vModel.AccountNumber,
									PayoutAmount: 1.00
								}).then(
									res => {
										if (res.body.IsValid) {
											this.$http.post(url, post).then(
												response => {

													this.$toastr("success", "Created Successfully");
													this.$router.push(route);
													this.isProcessing = false;
												},
												error => {
													this.isProcessing = false;
												}
											);
										} else {
											this.$toastr("error", res.body.Message);
										}
										this.isProcessing = false;
									},
									error => {
										this.isProcessing = false;
									}
								);

							} else {
								this.$http.post(
									url,
									post,
									{
										headers: {
											"Handle-Invalid-P2P-Name": "true"
										}
									}
								).then(
									response => {

										this.$toastr("success", "Created Successfully");
										this.$router.push(route);
										this.isProcessing = false;
									},
									error => {
										this.isProcessing = false;

										if (error.body && error.body.length > 0 && error.body[0].Message === "Invalid Receiver name for Personal Receiver Type.") {
											this.PendingReceiverFullName = `${this.vModel.FirstName} ${this.vModel.LastName}`.trim();
											this.ShowReceiverTypePopup = true;
											return;
										}
									}
								);
							}
						}
					}
				});

			},
			onChangeAgentDropDown: function () {
				var dropDownList = this.$refs.agentdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();

				if (selectedVlaue) {
					var promises = [];
					promises.push(
						ListService.getById("recipient/remarkbyagent/" + selectedVlaue)
					);

					Promise.all(promises).then(response => {
						if (response[0].body) {
							this.Remarks = response[0].body.Remarks;
							this.Note = response[0].body.Note;
							this.GroupCode = response[0].body.GroupCode;
						}
					});
				}
			},
			onChangeBankDropDown: function () {
				var dropDownList = this.$refs.bankdropdownlist.kendoWidget();
				var selectedValue = dropDownList.value();
				var selectedText = dropDownList.text();
				this.vModel.BankName = dropDownList.text();
				if (this.vModel.PayoutModeId == 1) {
					if (selectedValue) {
						var promises = [];
						promises.push(

							ListService.getAccountValidation(this.vModel.CountryId, this.vModel.PayoutModeId, selectedValue)
						);

						Promise.all(promises).then(response => {
							this.accountNoValidation = response[0].body;
						});
					}
				}

				if (this.FieldValidation != null && this.FieldValidation.BranchId != null) {
					this.selectedBranch = null;
					this.optionBranches = [];
					if (this.vModel.CountryId == 2) {
						this.vModel.BranchCode = null;
						this.IfscCode = null;
						return;
					}

					if (selectedValue) {
						var promises = [];
						promises.push(
							ListService.getById("list/branchbybank/" + selectedValue)
						);

						Promise.all(promises).then(response => {
							if (response[0].body) {
								this.$refs.branchdropdownlist
									.kendoWidget()
									.setDataSource(response[0].body);

								if (response[0].body.length == 1) {
									this.vModel.BranchId = response[0].body[0].Id;
								} else if (response[0].body.length == 0) {
									this.vModel.BranchId = null;
								}
							}

						});
					}
				}
				if (this.vModel.CountryId == 6 && this.vModel.PayoutModeId == 24) {
					this.showGcashAccountPrefix = false;
					if (selectedText.toUpperCase() == 'GCASH') {
						this.showGcashAccountPrefix = true;
						this.vModel.AccountPrefix = '09';
					}
				}
			},

			 onChangeWalletDropDown :function(){
				var dropDownList = this.$refs.wallettypelist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				var data  = this.WalletTypeCollection.filter(x=>x.Id==selectedVlaue);
				if(data.length > 0){
					this.vModel.AccountPrefix=null;
					var keyValueList = data[0].AccountPrefix;
					if (keyValueList.length > 0){
						this.IsPrefixAvaliable =true;
						this.$nextTick(function() {
							this.AccountPrefix = keyValueList.map((prefix, index) =>{ return { Id: index, Text: prefix };});
							if(this.AccountPrefix !=null)
								this.$refs.AccountPrefix.kendoWidget().text('');
							});
						}
					else
						this.resetPrefix();
				}
				else
					this.resetPrefix();
			},
			resetPrefix: function() {
						this.AccountPrefix = null;
						this.vModel.AccountPrefix = null;
						this.IsPrefixAvaliable = false;
					},
			onCancel: function () {
				this.vModel.PaymentNetworkId == "2" ? this.$router.push("/recipient/westernunion") : this.$router.push(
					"/recipient/merchantrade");
			},
			getNextFormData: function () {
				var promises = [];
				promises.push(ListService.getFeildValidate(this.vModel.CountryId, this.vModel.PayoutModeId),
					ListService.getRelationship(this.vModel.PayoutModeId, this.vModel.CountryId)
				);
				promises.push(ListService.getById("recipient/telcomobilecodelist"));
				promises.push(ListService.getById("list/recipientCompanyType"));
				promises.push(ListService.getById("list/receiveridtype/" + this.vModel.CountryId));

				Promise.all(promises).then(response => {

					if (response[0].body) {
						this.FieldValidation = response[0].body;

						if (this.FieldValidation.NationalityId && this.FieldValidation.NationalityId.IsReadOnlyField) {
							//Auto Select Nationality for China Union Pay Card or Alipay
							if (this.vModel.CountryId == 56 && (this.vModel.PayoutModeId == 21) || this.vModel.PayoutModeId == 22)
								this.vModel.NationalityId = 40;
							//Auto Select Nationality for Indonessia
							if (this.vModel.CountryId == 3 && this.vModel.PayoutModeId == 2)
								this.vModel.NationalityId = 85;
						}
					}
					if (response[1].body)
						this.RelationShipCollection = response[1].body;
					if (response[2].body) {
						this.CambodiaMobilePrefixCollection = response[2].body;
						if (response[2].body.length == 1) {
							this.vModel.TelcoMobileCodePrefix = response[2].body[0];
						}
					}
					if (response[3].body) {
						this.CompanyTypeCollection = response[3].body;
					}
					if (response[4].body) {
						this.ReceiverIdTypeCollection = response[4].body;
					}
				});
				if (this.vModel.PayoutModeId == 1 || this.vModel.PayoutModeId == 21 || this.vModel.PayoutModeId == 23 ||this.vModel.PayoutModeId == 24) {
					var promises = [];

					promises.push(ListService.getById("list/statebycountry/" + this.vModel.CountryId));


					promises.push(ListService.getById("list/bankbycountry/" + this.vModel.CountryId + "/" + this.vModel.PayoutModeId));

					promises.push(ListService.getStreetTypeByCountry(this.vModel.CountryId));

					promises.push(ListService.get("recipient/checkIfAccountValidationRequired/" + this.vModel.CountryId + "/" + this.vModel.PayoutModeId));
					Promise.all(promises).then(response => {

						this.StatesCollection = response[0].body;

						this.BankCollection = response[1].body;
						this.AllBanksList = [...this.BankCollection];

						this.StreetTypeCollection = response[2].body;

						this.IsAccountValidationRequired = response[3].body;
					});

				    if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 21 && this.vModel.PayoutGroupName != 'UNIONPAY THUNES') {
						this.IsUnionpayBtnDisabled = true;
				    }


					if (this.vModel.PayoutModeId == 1 && this.vModel.CountryId == 3) {
						this.IsIndonesiaBankAccBtnDisabled = true;
					}
				} else if (this.vModel.PayoutModeId == 2 || this.vModel.PayoutModeId == 34 || this.vModel.PayoutModeId == 35) {

					var promises = [];

					promises.push(
						ListService.getById(
							"list/agentbycountry/" +
							this.vModel.CountryId +
							"/" +
							this.vModel.PayoutModeId
						)
					);
					Promise.all(promises).then(response => {

						if (response[0].body) {
							this.AgentCollection = response[0].body;
						}

					});
				} else if (this.vModel.PayoutModeId == 23) {
					this.IsBkashBtnDisabled = true;
				}
				 else if(this.vModel.PayoutModeId == 31 || this.vModel.PayoutModeId == 32 || this.vModel.PayoutModeId == 33) {
					this.IsBtnDisabledforWallet = true;
				}
				else if (this.vModel.PayoutModeId == 25) {
					this.IsWingWalletBtnDisabled = true;
				} else if (this.vModel.PayoutModeId == 26) {
					this.IsMCBBtnDisabled = true;
				}
				else if (this.vModel.PayoutModeId ==27){
					this.IsWeixinWalletBtnDisabled=true;
				}
				else if (this.vModel.PayoutModeId == 1 && this.vModel.CountryId == 3) {
					this.IsIndonesiaBankAccBtnDisabled = true;
				}
				else if (this.vModel.PayoutModeId == 28)
				{
				  ListService.getById("list/WalletTypes/" + this.vModel.CountryId)
				.then(response => {
						if (response.body) {
							debugger
							this.WalletTypeCollection = response.body;

						}
					});
				}
				else if (this.vModel.PayoutModeId == 29 && this.vModel.CountryId == 10) {
					ListService.getById("list/WalletTypes/" + this.vModel.CountryId)
						.then(response => {
							if (response.body) {
								debugger
								this.WalletTypeCollection = response.body;

							}
						});
				}
			},

			onSearch(search, loading) {
				loading(true);
				this.search(loading, search, this);
			},
			search: _.debounce((loading, search, vm) => {

				vm.$http.post("list/branchbybank", {
					query: unescape(search),
					bankid: vm.vModel.BankId
				}).then(
					response => {
						vm.optionBranches = response.body;
						loading(false);
					},
					error => {
						loading(false);
					}
				);

			}, 350),

			onChangeIfscCode: function () {
				var model = {
					IFSC: this.vModel.BranchCode
				};
				this.$http.post("list/branch/ifsc", model).then(
					response => {
						this.vModel.BranchId = response.body.Id;
						this.vModel.BankId = response.body.BankId;
						this.vModel.BranchName = response.body.BranchName;
						this.vModel.BranchAddress = response.body.Address;
						this.IfscCode = this.vModel.BranchCode;

						this.selectedBranch = response.body.BranchName != null ? {
							Id: this.vModel.BranchId,
							Text: this.vModel.BranchName,
							Address: this.vModel.BranchAddress,
							BranchCode: this.vModel.BranchCode
						} : null;

					},

				);
			},
			verifybKash: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				}
				else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: "+88" + this.vModel.AccountNumber
				};
				this.IsBkashVerify = true;
				this.$http.post("v2/transaction/validate/bkash", model).then(
					response => {
						console.log(response);
						this.BKashFirstName = response.body.FirstName;
						this.BkashLastName = response.body.LastName;
						this.BkashReceiverName = response.body.FullName;
						if (response.body.IsValid == true) {
							if (response.body.IsNameMatched == true) {
								this.IsBkashBtnDisabled = false;
								this.IsValidBkashNumber = true;
							}
							else {
								this.IsValidBkashNumber = false;
								this.IsBkashBtnDisabled = true;
								this.ShowBkashNameMismatchPopup = true;
							}
						} else {
							this.IsValidBkashNumber = false;
							this.IsBkashBtnDisabled = true;
							//this.ShowBkashNameMismatchPopup = true;
						}
					},
					error => {
						this.IsValidBkashNumber = false;
						this.IsBkashBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsBkashVerify = false;
			},
			ValidateCommonwalletnumber: function () {
				if (this.vModel.LastName == "") {
					kendo.alert("Please Enter Last Name.");
					return;
				}
				if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				//else if (this.vModel.LastName == "") {
				//	kendo.alert("Please Enter Last Name.");
				//	return;
				//}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					PayoutModeId: this.vModel.PayoutModeId 
				};
				this.IsBkashVerify = true;
				this.$http.post("v2/transaction/validate/walletnumber", model).then(
					response => {
						console.log(response);
						this.BKashFirstName = response.body.FirstName;
						this.BkashLastName = response.body.LastName;
						this.BkashReceiverName = response.body.FullName;
						if (response.body.IsValid == true) {
							this.IsBtnDisabledforWallet = false;
							this.IsValidBkashNumber = true;							
						} else {
							this.IsValidBkashNumber = false;
							this.IsBtnDisabledforWallet = true;
							//this.ShowBkashNameMismatchPopup = true;
						}
					},
					error => {
						this.IsValidBkashNumber = false;
						this.IsBtnDisabledforWallet = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsBkashVerify = false;
			},
			verifyUnionpay: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Unionpay Card Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					ReceiverPhoneNo: this.vModel.MobileContact
				};
				this.$http.post("v2/transaction/validate/unionpay", model).then(
					response => {
						this.IsUnionpayVerify = true;
						if (response.body.IsValid == true) {
							this.IsValidUnionpayCardNumber = true;
							this.IsUnionpayBtnDisabled = false;
						} else {
							this.IsValidUnionpayCardNumber = false;
							this.IsUnionpayBtnDisabled = true;
						}
					},
					error => {
						this.IsValidUnionpayCardNumber = false;
						this.IsUnionpayBtnDisabled = true;
					}

				);
			},
			DeActivateSaveButton() {
				if (this.vModel.PayoutModeId == 1 && this.vModel.CountryId == 3) {
					this.IsIndonesiaBankAccBtnDisabled = true;
				}
			},
			handleYes: function () {
				this.IsValidBkashNumber = true;
				this.IsBkashBtnDisabled = false;
				//this.vModel.FirstName = this.BKashFirstName;
				this.vModel.FirstName = this.BkashReceiverName;
				this.vModel.LastName = this.BkashLastName;
				this.ShowBkashNameMismatchPopup = false;
				this.ShowWalletMismatchPopup = false;
			},

			handleNo: function () {
				this.IsValidBkashNumber = true;
				this.ShowBkashNameMismatchPopup = false;
				this.ShowWalletMismatchPopup = false;
			},

			verifyMCB: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.LastName == "") {
					kendo.alert("Please Enter Last Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber
				};
				this.IsMCBVerify = true;
				this.$http.post("v2/transaction/validate/mcb", model).then(
					response => {
						console.log(response);
						this.MCBFirstName = response.body.FirstName;
						this.MCBLastName = response.body.LastName;
						if (response.body.IsValid == true) {
							this.IsMCBBtnDisabled = false;
							this.IsValidMCBNumber = true;
						} else {
							this.IsValidMCBNumber = false;
							this.IsMCBBtnDisabled = true;
							this.ShowMCBNameMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidMCBNumber = false;
						this.IsMCBBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsMCBVerify = false;
			},

			validateWallet: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.LastName == "") {
					kendo.alert("Please Enter Last Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					GroupCode: this.GroupCode
				};
				this.IsMCBVerify = true;
				this.$http.post("v2/transaction/validate/walletnumber", model).then(
					response => {
						console.log(response);
						this.MCBFirstName = response.body.FirstName;
						this.MCBLastName = response.body.LastName;
						if (response.body.IsValid == true) {
							this.IsMCBBtnDisabled = false;
							this.IsValidMCBNumber = true;
						} else {
							this.IsValidMCBNumber = false;
							this.IsMCBBtnDisabled = true;
							this.ShowMCBNameMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidMCBNumber = false;
						this.IsMCBBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsMCBVerify = false;
			},

			handleYesMCB: function () {
				this.IsValidMCBNumber = true;
				this.IsMCBBtnDisabled = false;
				this.vModel.FirstName = this.MCBFirstName;
				this.vModel.LastName = this.MCBLastName;
				this.ShowMCBNameMismatchPopup = false;
			},

			handleNoMCB: function () {
				this.IsValidMCBNumber = true;
				this.ShowMCBNameMismatchPopup = false;
			},
			handleYesForIndonesiaAcc: function () {
				this.IsValidIndonesiaAccNumber = true;
				this.IsIndonesiaBankAccBtnDisabled = false;
				this.vModel.FirstName = this.IndonesiaAccountFirstName;
				this.vModel.LastName = this.IndonesiaAccountLastName;
				this.ShowIndonesiaAccountMismatchPopup = false;
			},

			handleNoForIndonesiaAcc: function () {
				this.IsValidIndonesiaAccNumber = true;
				this.ShowIndonesiaAccountMismatchPopup = false;
			},
			handleClose: function () {
				this.IsWingWalletBtnDisabled = true;
				this.ShowWingWalletCurrencyMismatchPopup = false;
				this.$refs['modal-wingwalletmismatch'].hide()
			},
			onChangeRelationship: function (evt) {
				var relationshipId = evt.target.value;
				if (relationshipId && this.additionalRelationshipCollection.includes(relationshipId))
					this.showAdditionalRelationshipMessage = true;
				else
					this.showAdditionalRelationshipMessage = false;
			},
			verifyWingWalletNumber: function () {
				if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					WingWalletNumber: this.vModel.AccountNumber,
					CurrencyId: this.vModel.CurrencyId
				};
				this.IsWingWalletVerify = true;
				this.$http.post("v2/transaction/validate/wingWalletNumber", model).then(
					response => {
						this.IsWingWalletValidationChecked = true;
						console.log(response);
						this.WingWalletFullName = response.body.FullName;
						this.WingWalletCurrency = response.body.ReceiverCurrency;
						if (response.body.IsValid == true) {
							this.IsWingWalletBtnDisabled = false;
							this.IsValidWingWalletNumber = true;
						} else {
							this.IsWingWalletBtnDisabled = true;
							this.IsValidWingWalletNumber = false;
							this.ShowWingWalletCurrencyMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidWingWalletNumber = false;
						this.IsWingWalletBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}
				);
				this.IsWingWalletVerify = false;
			},

			verifyWeixinWalletNumber: function () {
				if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				if (this.vModel.LastName == "") {
					kendo.alert("Please Enter Last Name.");
					return;
				}
				var model = {
					WeixinWalletNumber:"+" + this.vModel.AccountNumber,
					LastName: this.vModel.LastName
				};
				this.IsWeixinWalletVerify = true;

				this.$http.post("v2/transaction/validate/weixinwalletnumber", model).then(
					response => {
						this.IsWeixinWalletValidationChecked = true;
						console.log(response);
						this.WeixinWalletFullName = response.body.LastName;
						if (response.body.IsValid == true) {
							this.IsWeixinWalletBtnDisabled = false;
							this.IsValidWeixinWalletNumber = true;
						} else {
							this.IsWeixinWalletBtnDisabled = true;
							this.IsValidWeixinWalletNumber = false;
							this.ShowWeixinWalletCurrencyMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidWeixinWalletNumber = false;
						this.IsWeixinWalletBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}
				);
				this.IsWeixinWalletVerify = false;
			},
			verifyIndonesiaBankAccount: function () {
				if (this.vModel.ReceiverTypeId == 2) {
					if (this.vModel.Company == "") {
						kendo.alert("Please Enter Company Name.");
						return;
					}
				}
				else {
					if (this.vModel.FirstName == "") {
						kendo.alert("Please Enter First Name.");
						return;
					}
				}
				if (this.vModel.AccountNumber == null || this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Account Number.");
					return;
				}
				if (this.vModel.BankId == null || this.vModel.BankId == "") {
					kendo.alert("Please select a Bank.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					BankId: this.vModel.BankId
				};
				this.IsIndonesiaVerify = true;
				this.$http.post("v2/transaction/validate/indonesiabankaccount", model).then(
					response => {
						console.log(response);
						this.IndonesiaAccountFirstName = response.body.FirstName;
						this.IndonesiaAccountLastName = response.body.LastName;
						this.IndonesiaAccountReceiverName = response.body.FullName;
						if (response.body.IsValid == true) {
							if (response.body.IsNameMatched == true) {
								this.IsIndonesiaBankAccBtnDisabled = false;
								this.IsValidIndonesiaAccNumber = true;
							}
							else {
								this.IsValidIndonesiaAccNumber = false;
								this.IsIndonesiaBankAccBtnDisabled = true;
								this.ShowIndonesiaAccountMismatchPopup = true;
							}
						} else {
							this.IsValidIndonesiaAccNumber = false;
							this.IsIndonesiaBankAccBtnDisabled = true;
						}
					},
					error => {
						this.IsValidIndonesiaAccNumber = false;
						this.IsIndonesiaBankAccBtnDisabled = true;
					}

				);
				this.IsIndonesiaVerify = false;
			},
			handleReceiverTypeYes() {
				this.vModel.CompanyName = this.PendingReceiverFullName;
				this.vModel.FirstName = "";
				this.vModel.LastName = "";
				this.vModel.ReceiverTypeId = 2;
				this.ShowReceiverTypePopup = false;

				this.$nextTick(() => {
					if (this.$refs.receivertypedropdownlist && this.$refs.receivertypedropdownlist.kendoWidget) {
						this.$refs.receivertypedropdownlist
							.kendoWidget()
							.value(2);
					}

					this.onChangeReceiverType();

					this.vModel.CompanyName = this.PendingReceiverFullName;
				});
			},

			handleReceiverTypeNo() {
				this.vModel.FirstName = "";
				this.vModel.LastName = "";
				this.ShowReceiverTypePopup = false;
			}
		}
	};
</script>

<style>
	.form-card-header {
		padding: 0px 15px 75px 15px !important;
	}

		.form-card-header img {
			float: right;
			height: 75px;
		}

		.form-card-header h3 {
			float: left;
			height: 75px;
			padding-top: 25px;
		}

	.dropdown.v-select.single.searchable.input.bank-branch input[type="search"] {
		border: 0
	}

	.dropdown.v-select.single.searchable.input.bank-branch .dropdown-toggle::after {
		display: none;
	}

	.form-card-header {
		padding: 0px 15px 75px 15px !important;
	}

	.k-state-selected {
		background-color: rgb(6, 133, 245) !important;
	}

	.red-btn {
		background-color: #d5080f;
		color: #fff;
	}

	.right-option button:disabled .btn-content,
	button[disabled] {
		border: 1px solid #cccccc;
		background-color: #cccccc;
		color: #fff;
	}

	.right-option button:disabled .right-icon,
	button[disabled] {
		border: 1px solid #777171;
		background-color: #777171;
		color: #fff;
	}
</style>
<style scoped>
	select.form-control {
		-webkit-appearance: menulist;
	}
</style>
